import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { documentSearch, documentUpdate, documentStoreWithOutId } from '../../features/dashboard/DocumentRequestSlice';
import { findCustomer, mobileVerificationCode } from '../../features/dashboard/CustomerSlice'
import { fetchDocumentStatus, userDocumentStatus } from '../../features/dashboard/DocumentStatusSlice'
import { archiveIndex } from '../../features/dashboard/ArchiveSlice';
import Loading from '../../Loading';
import Header from './Header';
import Input from '../../component/form/Input';
import { ToastContainer, toast } from 'react-toastify';
import Message from '../form/Message'
import axios from 'axios';
import * as moment from 'jalali-moment';
import { host } from '../../function/api'
import $ from 'jquery'

import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import Select from "../form/Select";
import { sectionOneSearch, sectionThreeSearch, sectionTwoSearch } from "../../features/dashboard/SectionSlice";


function DocumentRequest() {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const documentId = useRef('')
    const [customerType, setCustomerType] = useState('nationalCode')
    const [MainWarehouse, setMainWarehouse] = useState('0')

    const [customerNumber, setCustomerNumber] = useState('')
    const [verificationCode, setVerificationCode] = useState('')
    const [response, setResponse] = useState(false)
    const [name, setName] = useState('')
    const [family, setFamily] = useState('')
    const [nationalCode, setNationalCode] = useState('')
    const [numberType, setNumberType] = useState('mt_pelakno')
    const [number, setNumber] = useState('')
    const [father_name, setFatherName] = useState('')
    const [idcard, setIdcard] = useState('')
    const [mobile, setMobile] = useState('')
    const [HashCode, setHashCodeNumber] = useState('')
    const [TextValidation, setTextValidation] = useState('')
    const [phone, setPhone] = useState('')
    const [address, setAddress] = useState('')
    const [postalcode, setPostalcode] = useState('')
    const [birthplace, setBirthplace] = useState('')
    const [placeofissue, setPlaceofissue] = useState('')
    const [birthdaye, setbirthdaye] = useState()
    const [type, setType] = useState('')
    const [value, setValue] = useState('')
    const [image, setImage] = useState('')
    const [rk_buyer_mobile_validation, setRk_buyer_mobile_validation] = useState('')
    const [rk_birth_certificate, setRk_birth_certificate] = useState('')
    const [rk_national_card, setRk_national_card] = useState('')
    const [rk_policy, setRk_policy] = useState('')
    const [rk_residence_verification, setRk_residence_verification] = useState('')
    const [rk_receipt, setRk_receipt] = useState('')
    const [rk_transfer_document, setRk_transfer_document] = useState('')
    const [rk_description, setRk_description] = useState('')
    const [rk_document_transfer, setRk_document_transfer] = useState('')
    const [rk_owner_validation_status, setRk_owner_validation_status] = useState('')
    const [OwnerHashCode, setOwnerHashCodeNumber] = useState('')
    const [OwnerBtnDisable, setOwnerBtnDisable] = useState('');
    const [OwnerMobile, setOwnerMobile] = useState('');
    const [OwnerVerificationCode, setOwnerVerificationCode] = useState('');
    const [OwnerBtnConfirm, setOwnerBtnConfirm] = useState('');
    const [OwnerBtnSms, setOwnerBtnSms] = useState('');
    const [OwnerTextValidation, setOwnerTextValidation] = useState('');
    const [OwnerBtnSubmit, setOwnerBtnSubmit] = useState('');
    const [rahkarpardaznet_document_status, setRahkarpardaznet_document_status] = useState('');
    const [rahpardaznetRandomString, setRahpardaznetRandomString] = useState('');
    const [RahpardaznetDetailsData, setRahpardaznetDetailsData] = useState({})
    const [RahpardaznetMessage, setRahpardaznetMessage] = useState('')


    let { loading, message, messeageCustomer, success, status } = useSelector(state => state.documentRequest);
    let { sms_status } = useSelector(state => state.customer);
    const {
        customerLoading,
        customerMessage,
        customerSuccess,
        customerStatus,
        customer,
        errorCustomerType,
        errorCustomerNumber,
        customerVerificationCode,
        verificationCodeMessage,
        errorVerificationCode
    } = useSelector(state => state.customer);
    const [btnSms, setBtnSms] = useState('');
    const [btnConfirm, setBtnConfirm] = useState('');
    const [btnDisable, setBtnDisable] = useState('');
    const [btnSubmit, setBtnSubmit] = useState('');
    const [btnFind, setBtnFind] = useState('');
    const [boxCustomer, setBoxCustomer] = useState('');

    const { archives } = useSelector(state => state.archive)
    const { statuses } = useSelector(state => state.status)
    const { sections, partOne, partTwo } = useSelector(state => state.section)

    const [dateObject, setDateObject] = useState(
        new DateObject()
    );

    const convert = (date, format = birthdaye.format) => {
        let object = { date, format }

        setbirthdaye({
            persian: new DateObject(object).convert(persian, persian_fa).format(),
            jsDate: date.toDate(),
            ...object
        })
    }
    const Span = ({ children }) => <span style={{ fontWeight: "bold" }}>{children}</span>

    let {
        internetMessage,
        customerStore,
        documentItem,
        errorName,
        errorFamily,
        errorNationalCode,
        errorNumberType,
        errorNumber,
        errorfather_name,
        errorBirthplace,
        errorIdcard,
        errorbirthdaye,
        errorPlaceofissue,
        errorMobile,
        errorPostalcode,
        errorPhone,
        errorAddress,
        errorType,
        errorValue
    } = useSelector(state => state.documentRequest)
    // set fetch data from kavir state
    const tp_karbari = useRef('')
    const tp_tip = useRef('')
    const cl_name = useRef('')
    const mt_model = useRef('')
    const tp_system = useRef('')
    const mt_bodyno = useRef('')
    const mt_motorno = useRef('')
    const mt_pelakno = useRef('')
    const mt_sanadno = useRef('')
    const fc_coname = useRef('')
    const tp_mehvar = useRef('')
    const tp_charkh = useRef('')
    const tp_zarfiyat = useRef('')
    const tp_cylandr = useRef('')
    const tp_sookht = useRef('')
    const tp_hajm = useRef('')
    const mt_pelakserial = useRef('')
    const mt_pelakdate = useRef('')


    
    const rahpardaznetChangeStore = async (event) => {
        event.preventDefault()
        if(typeof documentItem.sections == 'object' || documentItem.sections.length > 0){
            if(!MainWarehouse || MainWarehouse == '0'){
                $('html, body').animate({
                    scrollTop: $(".rahpardaznet-main-warehouse").offset().top
                }, 500);
                toast.error("انبار اصلی را انتخاب کنید.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                return;
            }

        }

        const data = {
            'mt_sanadno': mt_sanadno.current.innerHTML,
            'main_warehouse': MainWarehouse
        }
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}document/changeStore`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (response.data.status == true) {
                toast.success("انبار اصلی سند با موفقیت بروزرسانی شد.", {
                    position: "top-center",
                    autoClose: 1500,
                })
                
                
            }

        } catch (error) {
            
            toast.error(error.response.data.message, {
                position: "top-center",
                autoClose: 1200,
            })
        }

    }
    const documentUpdateHandler = async (event) => {
        event.preventDefault()

        if(typeof documentItem.sections == 'object' && documentItem.sections.length > 0){
            if(!MainWarehouse || MainWarehouse == '0'){
                $('html, body').animate({
                    scrollTop: $(".rahpardaznet-main-warehouse").offset().top
                }, 500);
                toast.error("انبار اصلی را انتخاب کنید.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                return;
            }

        }
        if (postalcode && postalcode.length > 1 && postalcode != " ") {

            let replacePostal = postalcode.replace(" ", "");
            if (replacePostal.length != 10) {
                toast.error("کدپستی نامعتبر است.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                return;
            }
        }

        if (mobile && mobile.length != 0 && mobile != " ") {
            let replaceMobile = mobile.replace(" ", "");
            if (replaceMobile && replaceMobile.length != 11) {
                toast.error("شماره موبایل باید 11 رقم باشد.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                return
            }
        }
        


        const data = {
            'tp_karbari': tp_karbari.current.innerHTML,
            'tp_tip': tp_tip.current.innerHTML,
            'cl_name': cl_name.current.innerHTML,
            'mt_model': mt_model.current.innerHTML,
            'tp_system': tp_system.current.innerHTML,
            'mt_bodyno': mt_bodyno.current.innerHTML,
            'mt_motorno': mt_motorno.current.innerHTML,
            'mt_pelakno': mt_pelakno.current.innerHTML,
            'mt_sanadno': mt_sanadno.current.innerHTML,
            'tp_mehvar': tp_mehvar.current.innerHTML,
            'tp_charkh': tp_charkh.current.innerHTML,
            'tp_zarfiyat': tp_zarfiyat.current.innerHTML,
            'tp_cylandr': tp_cylandr.current.innerHTML,
            'tp_sookht': tp_sookht.current.innerHTML,
            'tp_hajm': tp_hajm.current.innerHTML,
            'mt_pelakserial': mt_pelakserial.current.innerHTML,
            'mt_pelakdate': mt_pelakdate.current.innerHTML,
            'fc_coname': fc_coname.current.innerHTML,
            // customer data
            'name': name ? name : null,
            'family': family ? family : null,
            'nationalCode': customerNumber ? customerNumber : nationalCode,
            'father_name': father_name ? father_name : null,
            'idcard': idcard,
            'mobile': mobile,
            'phone': phone ? phone : null,
            'address': address ? address : null,
            'postalcode': postalcode,
            'birthplace': birthplace,
            'placeofissue': placeofissue,
            'birthdaye': birthdaye,
            // verification code
            'verificationCode': verificationCode,
            // other
            'rk_birth_certificate': rk_birth_certificate,
            'rk_national_card': rk_national_card,
            'rk_policy': rk_policy,
            'rk_residence_verification': rk_residence_verification,
            'rk_receipt': rk_receipt,
            'rk_description': rk_description,

            'status': rahkarpardaznet_document_status,
            // 'store_id': transferToStore,
            // 'section_id': sectionId,
            // 'part_one': partone,
            // 'part_two': parttwo,
            // 'part_three': partthree,
            'validation_mobile': btnSms,
            'main_warehouse': MainWarehouse
        }
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}documentRequest/storeWithOutId`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (response.data.status == true) {
                toast.success("سند با موفقیت ثبت شد.", {
                    position: "top-center",
                    autoClose: 1500,
                })
                setResponse(true)
                setName(' ');
                setFamily(' ');
                setNationalCode(' ');
                setFatherName(' ');
                setIdcard(' ');
                setMobile(' ');
                setPhone(' ');
                setAddress(' ');
                setPostalcode(' ');
                setBirthplace(' ');
                setPlaceofissue(' ');
                setbirthdaye(' ');
                setBoxCustomer('1');
                setBtnConfirm(' ');
                setBtnDisable(' ');
                setTextValidation(' ');
                setVerificationCode(' ');
                setOwnerHashCodeNumber(' ');
                setOwnerBtnDisable(' ');
                setOwnerMobile(' ');
                setOwnerVerificationCode(' ');
                setOwnerBtnConfirm(' ');
                setOwnerBtnSms(' ');
                setOwnerTextValidation(' ');
                setOwnerBtnSubmit(' ');
                setBoxCustomer(' ');
                setRk_birth_certificate(' ');
                setRk_national_card(' ');
                setRk_policy(' ');
                setRk_residence_verification(' ');
                setRk_receipt(' ');
                setRk_transfer_document(' ');
                setRk_description(' ');
                setRk_document_transfer(' ');
                setRk_owner_validation_status(' ');
                setNumber(null);
                $('#SearchNumber').val('');
                setNumberType('mt_pelakno');
                $('#SearchNumberType').val('');
                const datas = {
                    'numberType': 'mt_sanadno',
                    'number': mt_sanadno.current.innerHTML,
                    'access': localStorage.getItem('access')
                }

                // console.log(localStorage.getItem('access'));
                dispatch(documentSearch(datas));
            }

        } catch (error) {
            if (error.response.data.error) {
                const listError = error.response.data.error;
                // console.log(listError);

                $.each(listError, function (index, value) {
                    // error+index = value[0];
                    if (typeof (value) == 'object') {
                        toast.error(value[0], {
                            position: "top-center",
                            autoClose: 5000,
                        })
                    } else {
                        toast.error(value, {
                            position: "top-center",
                            autoClose: 5000,
                        })
                    }
                });
            }

        }
        // dispatch(documentStoreWithOutId(data));
        // setResponse(true)

        // const data2 = {
        //     'numberType': numberType,
        //     'number': number,
        //     'access': localStorage.getItem('access')
        // }
        // // console.log(localStorage.getItem('access'));
        // dispatch(documentSearch(data));

    }
    const token = localStorage.getItem('token')

    const documentUpdateTransferHandler = async (event) => {
        event.preventDefault()
        if (postalcode && postalcode.length > 1 && postalcode != " ") {

            let replacePostal = postalcode.replace(" ", "");
            if (replacePostal.length != 10) {
                toast.error("کدپستی نامعتبر است.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                return;
            }
        }

        if (mobile && mobile.length > 0 && mobile != " ") {
            let replaceMobile = mobile.replace(" ", "");
            if (replaceMobile && replaceMobile.length != 11) {
                toast.error("شماره موبایل باید 11 رقم باشد.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                return
            }
        }
        const data = {
            'tp_karbari': tp_karbari.current.innerHTML,
            'tp_tip': tp_tip.current.innerHTML,
            'cl_name': cl_name.current.innerHTML,
            'mt_model': mt_model.current.innerHTML,
            'tp_system': tp_system.current.innerHTML,
            'mt_bodyno': mt_bodyno.current.innerHTML,
            'mt_motorno': mt_motorno.current.innerHTML,
            'mt_pelakno': mt_pelakno.current.innerHTML,
            'mt_sanadno': mt_sanadno.current.innerHTML,
            'tp_mehvar': tp_mehvar.current.innerHTML,
            'tp_charkh': tp_charkh.current.innerHTML,
            'tp_zarfiyat': tp_zarfiyat.current.innerHTML,
            'tp_cylandr': tp_cylandr.current.innerHTML,
            'tp_sookht': tp_sookht.current.innerHTML,
            'tp_hajm': tp_hajm.current.innerHTML,
            'mt_pelakserial': mt_pelakserial.current.innerHTML,
            'mt_pelakdate': mt_pelakdate.current.innerHTML,
            // customer data
            'name': name ? name : null,
            'family': family ? family : null,
            'nationalCode': customerNumber ? customerNumber : nationalCode,
            'father_name': father_name ? father_name : null,
            'idcard': idcard,
            'mobile': mobile,
            'phone': phone ? phone : null,
            'address': address ? address : null,
            'postalcode': postalcode,
            'birthplace': birthplace,
            'placeofissue': placeofissue,
            'birthdaye': birthdaye,
            // verification code
            'verificationCode': verificationCode,
            // other
            'rk_birth_certificate': rk_birth_certificate,
            'rk_national_card': rk_national_card,
            'rk_policy': rk_policy,
            'rk_residence_verification': rk_residence_verification,
            'rk_receipt': rk_receipt,
            'rk_description': rk_description,
            'owner_mobile': OwnerMobile ? OwnerMobile : documentItem.customer_data.mobile,

            'hash_code': documentItem.RandString
        }
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}documentTransfer`,
                data: data,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (response.data.status == true) {
                toast.success("انتقال سند با موفقیت ثبت شد.", {
                    position: "top-center",
                    autoClose: 1500,
                })
                $('.fileinput-remove-button').trigger('click');
                $('.rahpardaznet-upload-file').addClass('d-none');

                setResponse(true)
                setName(' ');
                setFamily(' ');
                setNationalCode(' ');
                setFatherName(' ');
                setIdcard(' ');
                setMobile(' ');
                setPhone(' ');
                setAddress(' ');
                setPostalcode(' ');
                setBirthplace(' ');
                setPlaceofissue(' ');
                setbirthdaye(' ');
                setBoxCustomer('1');
                setBtnConfirm(' ');
                setBtnDisable(' ');
                setTextValidation(' ');
                setVerificationCode(' ');
                setOwnerHashCodeNumber(' ');
                setOwnerBtnDisable(' ');
                setOwnerMobile(' ');
                setOwnerVerificationCode(' ');
                setOwnerBtnConfirm(' ');
                setOwnerBtnSms(' ');
                setOwnerTextValidation(' ');
                setOwnerBtnSubmit(' ');
                setBoxCustomer(' ');
                setRk_birth_certificate(' ');
                setRk_national_card(' ');
                setRk_policy(' ');
                setRk_residence_verification(' ');
                setRk_receipt(' ');
                setRk_transfer_document(' ');
                setRk_description(' ');
                setRk_document_transfer(' ');
                setRk_owner_validation_status(' ');
                const datas = {
                    'numberType': 'mt_sanadno',
                    'number': mt_sanadno.current.innerHTML,
                    'access': localStorage.getItem('access')
                }


                // console.log(localStorage.getItem('access'));
                dispatch(documentSearch(datas));




            }

        } catch (error) {
            if (typeof (error.response) == 'object') {
                const listError = error.response.data.error;
                // console.log(listError);

                $.each(listError, function (index, value) {
                    // error+index = value[0];
                    if (typeof (value) == 'object') {
                        toast.error(value[0], {
                            position: "top-center",
                            autoClose: 5000,
                        })
                    } else {
                        toast.error(value, {
                            position: "top-center",
                            autoClose: 5000,
                        })
                    }
                });
            }
        }
    }
    const change = (unix, formatted) => {
        console.log(unix); // returns timestamp of the selected value, for example.
        console.log(formatted); // returns the selected value in the format you've entered, forexample, "تاریخ: 1396/02/24 ساعت: 18:30".
    }
    const documentSearchHandler = (event) => {
        event.preventDefault()
        if (rk_document_transfer == true && rk_document_transfer != " ") {
            $('.fileinput-remove-button').trigger('click');
            $('.rahpardaznet-upload-file').addClass('d-none');
        }

        setResponse(true)

        const data = {
            'numberType': numberType,
            'number': number,
            'access': localStorage.getItem('access')
        }
        // console.log(localStorage.getItem('access'));
        setName(' ');
        setFamily(' ');
        setNationalCode(' ');
        setFatherName(' ');
        setIdcard(' ');
        setMobile(' ');
        setPhone(' ');
        setAddress(' ');
        setPostalcode(' ');
        setBirthplace(' ');
        setPlaceofissue(' ');
        setbirthdaye(' ');
        setBoxCustomer('1');
        setBtnConfirm(' ');
        setBtnDisable(' ');
        setTextValidation(' ');
        setVerificationCode(' ');
        setOwnerHashCodeNumber(' ');
        setOwnerBtnDisable(' ');
        setOwnerMobile(' ');
        setOwnerVerificationCode(' ');
        setOwnerBtnConfirm(' ');
        setOwnerBtnSms(' ');
        setOwnerTextValidation(' ');
        setOwnerBtnSubmit(' ');
        setBoxCustomer(' ');
        setRk_birth_certificate(' ');
        setRk_national_card(' ');
        setRk_policy(' ');
        setRk_residence_verification(' ');
        setRk_receipt(' ');
        setRk_transfer_document(' ');
        setRk_description(' ');
        setRk_document_transfer(' ');
        setRk_owner_validation_status(' ');
        setCustomerNumber(null);
        $('#customerNumber').val('');

        dispatch(documentSearch(data));

    }
    // const newDocumentRequestHandler = (event) => {
    //     event.preventDefault()
    //     window.location.reload(false);
    //     navigate('/dashboard/document')
    // }


    const documentStatusUpdateHandler = (id) => {
        setRahkarpardaznet_document_status(id);
    }
    const documentPrintHandlerone = async (event) => {
        event.preventDefault()
        var documentItem2 = JSON.parse(JSON.stringify(documentItem));
        documentItem2.date = new Date().toLocaleDateString('fa-IR');
        Object.preventExtensions(documentItem2);
        const data = documentItem2


        try {
            const res = await axios({
                method: 'POST',
                url: `${host}document/sanad/pdf`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            if (res.data.status == true) {
                window.open(
                    res.data.link,
                    '_blank' // <- This is what makes it open in a new window.
                );
                toast.success("فایل صفحه اول سند دانلود شد.", {
                    position: "top-center",
                    autoClose: 1200,
                })
            }

        } catch (error) {
            toast.error("خطایی پیش آمد.", {
                position: "top-center",
                autoClose: 1200,
            })
        }

    }
    const documentPrintHandlertwo = async (event) => {
        event.preventDefault()
        const data = {
            'fullName': documentItem.customer_data.name + " " + documentItem.customer_data.family,
            'nationalCode': documentItem.customer_data.nationalCode

        }


        try {
            const res = await axios({
                method: 'POST',
                url: `${host}document/sanad/pdf/back`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            if (res.data.status == true) {
                window.open(
                    res.data.link,
                    '_blank' // <- This is what makes it open in a new window.
                );
                toast.success("فایل صفحه دوم سند دانلود شد.", {
                    position: "top-center",
                    autoClose: 1200,
                })
            }

        } catch (error) {
            toast.error("خطایی پیش آمد.", {
                position: "top-center",
                autoClose: 1200,
            })
        }


    }


    const RahpardaznetValidationNationalCode = (number) => {
        if (!/^\d{10}$/.test(number)) return false;
        const check = +number[9];
        const sum = number.split('').slice(0, 9).reduce((acc, x, i) => acc + +x * (10 - i), 0) % 11;
        return sum < 2 ? check === sum : check + sum === 11;

    }
    const customerSearchHandler = async (event) => {
        event.preventDefault()

        if (rk_document_transfer == true && rk_document_transfer != " ") {
            $('.fileinput-remove-button').trigger('click');
            $('.rahpardaznet-upload-file').addClass('d-none');
        }

        setBoxCustomer(' ');
        if (customerNumber.length != 11) {
            if (RahpardaznetValidationNationalCode(customerNumber) !== true) {
                toast.error("کدملی نامعتبر است.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                return;
            }
        }

        setBtnFind('1');
        setOwnerBtnSubmit('0');
        const data = {
            'type': 'nationalCode',
            'number': customerNumber
        }
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}customer/find`,
                data: data,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (response.data.status == true) {
                setName(response.data.data.name);
                setFamily(response.data.data.family);
                setNationalCode(response.data.data.nationalCode);
                setFatherName(response.data.data.father_name);
                setIdcard(response.data.data.idcard);
                setMobile(response.data.data.mobile);
                setPhone(response.data.data.phone);
                setAddress(response.data.data.address);
                setPostalcode(response.data.data.postalcode);
                setBirthplace(response.data.data.birthplace);
                setPlaceofissue(response.data.data.placeofissue);
                setbirthdaye(response.data.data.birthdaye ? response.data.data.birthdaye : null);
                setBoxCustomer('1');
                setBtnConfirm(' ');
                setBtnDisable(' ');
                setTextValidation(' ');
                setVerificationCode(' ');
                setBtnSms('3');

            } else {
                setName(' ');
                setFamily(' ');
                setNationalCode(' ');
                setFatherName(' ');
                setIdcard(' ');
                setMobile(' ');
                setPhone(' ');
                setAddress(' ');
                setPostalcode(' ');
                setBirthplace(' ');
                setPlaceofissue(' ');
                setbirthdaye(' ');
                setBoxCustomer('1');
                setBtnConfirm(' ');
                setBtnDisable(' ');
                setTextValidation(' ');
                setVerificationCode(' ');
                setBtnSms('3');
                if (customerNumber.length == 10) {
                    toast.error("کاربری با این کد ملی پیدا نشد.", {
                        position: "top-center",
                        autoClose: 1200,
                    })
                } else {
                    toast.error("پیدا نشد وبه عنوان شرکت حقوقی ثبت می شود.", {
                        position: "top-center",
                        autoClose: 1200,
                    })
                }

            }


        } catch (error) {
            setName(' ');
            setFamily(' ');
            setNationalCode(' ');
            setFatherName(' ');
            setIdcard(' ');
            setMobile(' ');
            setPhone(' ');
            setAddress(' ');
            setPostalcode(' ');
            setBirthplace(' ');
            setPlaceofissue(' ');
            setbirthdaye(' ');
            setBoxCustomer('1');
            setBtnConfirm(' ');
            setBtnDisable(' ');
            setTextValidation(' ');
            setVerificationCode(' ');

            setBtnSms('3');

            if (customerNumber.length == 10) {
                toast.error("کاربری با این کد ملی پیدا نشد.", {
                    position: "top-center",
                    autoClose: 1200,
                })
            } else {
                toast.error("پیدا نشد وبه عنوان شرکت حقوقی ثبت می شود.", {
                    position: "top-center",
                    autoClose: 1200,
                })
            }
        }
        if (rk_document_transfer == true && rk_document_transfer != " ") {
            $('.fileinput-remove-button').trigger('click');
            $('.rahpardaznet-upload-file').removeClass('d-none');
        }

        setBtnFind('');

    }
    // data set variables
    const [transferToStore, setTransferToStore] = useState('')
    const [section, setSection] = useState('')
    const [sectionId, setSectionId] = useState('')
    const [partone, setPartone] = useState('')
    const [parttwo, setParttwo] = useState('')
    const [partthree, setPartthree] = useState('')
    const [RahpardaznetSectionOne, setRahpardaznetSectionOne] = useState('')
    const [RahpardaznetSectionTwo, setRahpardaznetSectionTwo] = useState('')
    const [RahpardaznetSectionMain, setRahpardaznetSectionMain] = useState('')
    const verivicationCodeHandler = async (e) => {
        e.preventDefault();
        setBtnSms('1');
        const data = {
            mobile: mobile ? mobile : null
        }


        setHashCodeNumber("");

        try {
            const res = await axios({
                method: 'POST',
                url: `${host}customer/mobile/verificationCode`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            if (res.status == 200) {
                toast.success("پیامک با موفقیت ارسال شد.", {
                    position: "top-center",
                    autoClose: 1200,
                })


                setBtnSms('3');
                setHashCodeNumber(res.data.hash);
                setBtnConfirm('1');
            } else {
                toast.error("پیامک ارسال نشد.", {
                    position: "top-center",
                    autoClose: 1200,
                })

                setBtnSms('3');
            }

        } catch (error) {
            toast.error("پیامک ارسال نشد.", {
                position: "top-center",
                autoClose: 1200,
            })

            setBtnSms('3');
        }
        // dispatch(mobileVerificationCode(data))
        // console.log(sms_status);

    }
    const transferStoreHandler = (value) => {
        setTransferToStore(value)
        const searchItem = {
            'store_id': value
        }
        dispatch(sectionOneSearch(searchItem))
    }

    const sectionOneSearchHandler = (value) => {
        setPartone(value)
        const partOneItem = {
            'section_one_id': value,
        }
        dispatch(sectionTwoSearch(partOneItem));
    }

    const sectionTwoSearchHandler = (value) => {
        setParttwo(value)
        const partTwoItem = {
            'section_two_id': value,
        }
        dispatch(sectionThreeSearch(partTwoItem));
    }
    const validationCodeHandler = async (e) => {
        e.preventDefault();
        setBtnSms('1');
        setBtnDisable("1");
        const data = {
            mobile: mobile,
            code: verificationCode,
            hash: HashCode
        }


        try {
            const res = await axios({
                method: 'POST',
                url: `${host}customer/mobile/validationCode`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            if (res.data.status) {
                toast.success("اعتبار سنجی با موفقیت انجام شد.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                setBtnSubmit('1');
                setTextValidation('1');
                setBtnSms('2');
                setOwnerBtnSubmit('1');
            } else {
                toast.error("کد تایید نامعتبر است.", {
                    position: "top-center",
                    autoClose: 1200,
                })

                setBtnSms('3');

                setBtnDisable("");
            }

        } catch (error) {
            toast.error("کد تایید نا معتبر است.", {
                position: "top-center",
                autoClose: 1200,
            })

            setBtnSms('3');

            setBtnDisable("");
        }


        // dispatch(mobileVerificationCode(data))
        // console.log(sms_status);

    }


    const OwnerVerificationCodeHandler = async (e) => {
        e.preventDefault();
        setOwnerBtnSms('1');
        const data = {
            mobile: OwnerMobile ? OwnerMobile : documentItem.customer_data.mobile
        }


        setOwnerHashCodeNumber("");

        try {
            const res = await axios({
                method: 'POST',
                url: `${host}customer/mobile/verificationCode`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            if (res.status == 200) {
                toast.success("پیامک با موفقیت ارسال شد.", {
                    position: "top-center",
                    autoClose: 1200,
                })


                setOwnerBtnSms('');
                setOwnerHashCodeNumber(res.data.hash);
                setOwnerBtnConfirm('1');
            } else {
                toast.error("پیامک ارسال نشد.", {
                    position: "top-center",
                    autoClose: 1200,
                })

                setOwnerBtnSms('');
            }

        } catch (error) {
            toast.error("پیامک ارسال نشد.", {
                position: "top-center",
                autoClose: 1200,
            })

            setOwnerBtnSms('');
        }

        // dispatch(mobileVerificationCode(data))
        // console.log(sms_status);

    }


    const OwnerValidationCodeHandler = async (e) => {
        e.preventDefault();
        setOwnerBtnSms('1');
        setOwnerBtnDisable("1");
        const data = {
            mobile: OwnerMobile ? OwnerMobile : documentItem.customer_data.mobile,
            code: OwnerVerificationCode,
            hash: OwnerHashCode
        }


        try {
            const res = await axios({
                method: 'POST',
                url: `${host}customer/mobile/validationCode`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            if (res.data.status) {
                toast.success("اعتبار سنجی مالک با موفقیت انجام شد.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                setRk_owner_validation_status('1');
                setOwnerTextValidation('1');
                setOwnerBtnSms('');
            } else {
                toast.error("کد تایید نامعتبر است.", {
                    position: "top-center",
                    autoClose: 1200,
                })

                setOwnerBtnSms('');

                setOwnerBtnDisable("");
            }

        } catch (error) {
            toast.error("کد تایید نا معتبر است.", {
                position: "top-center",
                autoClose: 1200,
            })

            setOwnerBtnSms('');

            setOwnerBtnDisable("");
        }


        // dispatch(mobileVerificationCode(data))
        // console.log(sms_status);

    }
    useEffect(() => {



        $("#rahpardaznet-image-file").fileinput({
            theme: 'fa',
            uploadUrl: `${host}document/status/upload-image`,
            uploadExtraData: function () {
                return {
                    'code': mt_sanadno.current.innerHTML,
                    'mt_sanadno': mt_sanadno.current.innerHTML,
                    'statusid': '0'
                };
            },
            allowedFileExtensions: ['jpg', 'png', 'gif', 'jpeg', 'pdf'],
            overwriteInitial: false,
            maxFileSize: 2048,
            maxFilesNum: 10
        });
    }), [];

    useEffect(() => {
        if (loading === false && success === true) {


            if (typeof documentItem === 'object' && Object.keys(documentItem).length != 0) {

                setMainWarehouse(documentItem.main_warehouse);



            }
            if (typeof documentItem === 'object' && Object.keys(documentItem).length != 0 && typeof documentItem.factor_data === 'object' && Object.keys(documentItem.factor_data).length != 0) {

                setCustomerNumber(documentItem.factor_data.nationalCode);
                $(document).ready(function () {
                    $('.rahpardaznet-search-btn').trigger('click');
                });


            }

            if (typeof documentItem === 'object' && Object.keys(documentItem).length != 0 && documentItem.document_id > 0) {
                getDocumentDetails();
            }

            if (typeof documentItem === 'object' && Object.keys(documentItem).length != 0 && documentItem.RandString) {
                console.log(documentItem.RandString);
                let aaaaa = documentItem.RandString;
                $("#image-file").fileinput({
                    theme: 'fa',
                    uploadUrl: `${host}document/upload-image/${documentItem.mt_sanadno}/${documentItem.RandString}`,
                    uploadExtraData: function () {
                        return {
                        };
                    },
                    allowedFileExtensions: ['jpg', 'png', 'gif', 'jpeg', 'pdf'],
                    overwriteInitial: false,
                    maxFileSize: 2048,
                    maxFilesNum: 10
                });
            }




            if (message != "") {
                toast.success(message, {
                    position: "top-center",
                    autoClose: 1200,
                })
            }

            message = ""
        }


    }, [loading, success, response])




    const getDocumentDetails = async () => {

        try {

            const data = {
                'mt_sanadno': mt_sanadno.current.innerHTML,
                'status': 0,
            }
            const response = await axios({
                method: 'post',
                url: `${host}document/details`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            setRahpardaznetDetailsData(response.data.data);

        } catch (error) {
            toast.error("خطایی پیش آمد مجددا تلاش نمایید.", {
                position: "top-center",
                autoClose: 1200,
            })
        }
    };



    const RahpardaznetSubmitMessage = async (e) => {
        e.preventDefault()
        if (RahpardaznetMessage == null || RahpardaznetMessage == " ") {
            toast.error("یادداشت خالی می باشد.", {
                position: "top-center",
                autoClose: 1200,
            })
            return;
        }
        // alert(RahpardaznetMessage);
        const data = {
            'message': RahpardaznetMessage,
            'mt_sanadno': mt_sanadno.current.innerHTML,
            'status_id': '0'
        }
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}document/status/message`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })

            if (response.data.status == true) {
                toast.success('یادداشت با موفقیت ایجاد شد.', {
                    position: "top-center",
                    autoClose: 1200,
                })
                getDocumentDetails();
                $(".rahpardaznet-list-message").animate({
                    scrollTop: $('.rahpardaznet-list-message').get(0).scrollHeight
                }, 1500);
                setRahpardaznetMessage(' ');

            }

        } catch (error) {
            toast.error("یادداشت اضافه نشد.", {
                position: "top-center",
                autoClose: 1200,
            })
        }
    };



    const RahpardaznetDefaultNote = (message) => {
        setRahpardaznetMessage(RahpardaznetMessage + " " + message);
    }
    useEffect(() => {
        dispatch(archiveIndex(token))
        dispatch(fetchDocumentStatus(token))


    }, [])
    useEffect(() => {
        if (typeof documentItem === 'object' && Object.keys(documentItem).length != 0 && documentItem.status_document_id) {
            setRahkarpardaznet_document_status(documentItem.status_document_id);
        } else {
            setRahkarpardaznet_document_status(documentItem.status_document_id);
        }



    }, [documentItem])






    useEffect(() => {

        setNumber('');

    }, [numberType])
    useEffect(() => {

        dispatch(userDocumentStatus(localStorage.getItem('token')))


    }, [])
    const internetMessageHandler = () => {
        // dispatch(internetMessageChange)
    }



    return (

        // internetMessage === '' ?
        // (
        <>
            {loading ? (<Loading />) : null}
            <div className="page-header">
                <div className="container-fluid d-sm-flex justify-content-between">
                    <h6>نوبت دهی صدور سند</h6>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                کویر موتور
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">نوبت دهی</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="text-end" style={{ direction: 'rtl' }}>
                {/* {
(Object.keys(documentItem).length == 0 && success === false) ? ( */}
                <div className='row rahpardaznet-cart  print-position'>
                    <Header title={'درخواست سند'} />
                    <div className="col-12">
                        <form onSubmit={documentSearchHandler}>
                            <div className='rahpardaz-search-form-select'>

                                <select
                                    value={numberType}
                                    defaultValue={'mt_pelakno'}
                                    onChange={(e) => setNumberType(e.target.value)}
                                    id="SearchNumberType"
                                    className="form-control form-select form-select-lg shadow-none"
                                    aria-label="form-select-lg example">
                                    <option value='DEFAULT' selected disabled>یک مورد را انتخاب کنید</option>
                                    <option value='mt_pelakno'>شماره پلاک</option>
                                    <option value='mt_bodyno'>شماره شاسی</option>
                                    <option value='mt_sanadno'>شماره سند</option>
                                </select>


                                {
                                    numberType === 'mt_pelakno' ? (
                                        <Input
                                            key='2'
                                            tab='2'
                                            col='col-12'
                                            type='text'
                                            maxLength={25}
                                            name='number'
                                            value={number}
                                            onchange={(e) => setNumber(e.target.value)}
                                            placeholder='شماره پلاک را وارد نمایید.'
                                            error={errorNumber}
                                            id="SearchNumber"
                                            focus='1'
                                            keyup={true}

                                        />
                                    ) : (
                                        <Input
                                            key='2'
                                            tab='2'
                                            col='col-12'
                                            type='text'
                                            name='number'
                                            value={number}
                                            onchange={(e) => setNumber(e.target.value)}
                                            id="SearchNumber"
                                            placeholder='شماره شاسی یا سند را وارد نمایید.'
                                        />


                                    )

                                }

                                <button
                                    type="submit"
                                    className="print-no">
                                    {'  جستجوی انبار  '}

                                </button>

                            </div>
                            {
                                (errorNumberType) ? (
                                    <span className="help-block d-inline-block mt-2">
                                        <small className='text-danger validate-error'>{errorNumberType}</small>
                                    </span>
                                ) : ''}
                            {
                                (errorNumber) ? (
                                    <span className="help-block d-inline-block mt-2">
                                        <small className='text-danger validate-error'>{errorNumber}</small>
                                    </span>
                                ) : ''}
                            {/* {
            (documentItem && documentItem.length != 0 &&  message)  ? (
            <h6 className='text-end text-muted mt-3 mb-0'>
                <i className="fa-regular fa-bell fa-lg fa-fw fa-stack"></i>
                {message}
            </h6>
            ) : null
            } */}
                        </form>
                    </div>
                </div>
                {/* ) : null
} */}

                {
                    (typeof documentItem === 'object') ? (
                        (Object.keys(documentItem).length != 0 && response === true) ? (
                            <>

                                <div className='row rahpardaznet-cart  my-5  print-position'>

                                    <Header title='اطلاعات انبار' />
                                    <div>

                                        {
                                            (typeof documentItem.sections == 'object' && documentItem.sections.length > 0) ? (
                                                <>
                                                    {
                                                        documentItem.sections.map((section, key) => (
                                                            <div className={MainWarehouse == section.section_main.id ? 'active-main-warehouse col-12 d-flex rahpardaznet-section-box' : 'section col-12 d-flex rahpardaznet-section-box'}>
                                                                <div className='rahpardaznet-section section-main'>{section.section_main.name}</div>
                                                                <div className='rahpardaznet-section section-one'>{section.section_one.name}</div>
                                                                <div className='rahpardaznet-section section-two'>{section.section_two.name}</div>
                                                                <div className='rahpardaznet-section section-three'>{section.section_three.name}</div>
                                                            </div>
                                                        ))
                                                    }
                                                </>
                                            ) : (
                                                <div>انباری جهت نمایش وجود ندارد.</div>
                                            )
                                        }

                                    </div>

                                </div>
                                {
                                    (typeof documentItem.sections == 'object' && documentItem.sections.length > 0) ? (
                                        <div className='row rahpardaznet-cart rahpardaznet-main-warehouse  my-5  print-position'>

                                            <Header title='انبار اصلی' />
                                            <div className='rahpardaz-search-form-select'>
                                
                                                <select
                                                    value={MainWarehouse}
                                                    defaultValue={documentItem.main_warehouse}
                                                    className='form-control form-select form-select-lg shadow-none section'
                                                    onChange={(e) => setMainWarehouse(e.target.value)}
                                                >
                                                    <option value="0" disabled>انتخاب کنید ...</option>
                                                    {
                                                        documentItem.sections.map((section, key) => (
                                                            <option value={section.section_main.id}>{section.section_main.name}</option>
                                                        ))
                                                    }
                                                </select>
                                                {
                                                    (documentItem.saved == "saved" && documentItem.customer_data != null && documentItem.customer_data != []) ? (
                                                        <button
                                                            onClick={rahpardaznetChangeStore}
                                                            type="submit"
                                                            className="print-no rahpardaznet-search-btn">
                                                            {btnFind ? (<div className="spinner-border text-light"
                                                                role="status"></div>) : "تغیر انبار"}
                                                            {'   '}

                                                        </button>
                                                    ) : null
                                                }
                                            </div>

                                        </div>
                                    ) : null
                                }

                                <div className='row rahpardaznet-cart  my-5  print-position'>
                                    {
                                        !documentItem.id ? (
                                            <Header title='اطلاعات کارخانه' />
                                        )
                                            : (
                                                <Header title='اطلاعات انبار' />
                                            )
                                    }
                                    <div
                                        className='col-4 col-md-4 p-3 list-group list-group-flush d-flex flex-column  align-items-center border font'>
                                        <input type="hidden" ref={documentId} value={documentItem.id} />
                                        <input type="hidden" ref={mt_sanadno} value={documentItem.mt_sanadno} />
                                        <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex fs-5">
                                            {
                                                (documentItem.mt_pelakno != '0') ? (
                                                    <div
                                                        className='d-flex flex-column justify-content-center align-items-center rahpardaznet-pelak rahpardaznet-pelak-box'>
                                                        <span
                                                            ref={mt_pelakserial}>{documentItem.mt_pelakserial.replace("ایران", "")}</span>
                                                        <span ref={mt_pelakno}>
                                                            {documentItem.mt_pelakno}
                                                        </span>
                                                    </div>
                                                ) : (
                                                    <div className='rahpardaznet-pelakno'>
                                                        <span className="d-none"
                                                            ref={mt_pelakserial}>{documentItem.mt_pelakserial.replace("ایران", "")}</span>
                                                        <span className="d-none" ref={mt_pelakno}>
                                                            {documentItem.mt_pelakno}
                                                        </span>
                                                        <span className='text-danger'>بدون پلاک</span>
                                                    </div>
                                                )
                                            }

                                        </li>
                                        <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex fs-5">
                                            <label> تاریخ نصب : </label>
                                            <span ref={mt_pelakdate}>{documentItem.mt_pelakdate}</span>
                                        </li>
                                        <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex fs-5">
                                            <label> شماره سند : </label>
                                            <span ref={mt_sanadno}>{documentItem.mt_sanadno}</span>
                                        </li>

                                        <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex fs-5">
                                            <label> شرکت: </label>
                                            <span ref={fc_coname}>{documentItem.fc_coname}</span>
                                        </li>
                                    </div>
                                    <div className="col-4 col-md-4 p-3 list-group list-group-flush border">
                                        <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                            <label> نوع کاربری : </label>
                                            <span ref={tp_karbari}>{documentItem.tp_karbari}</span>
                                        </li>

                                        <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                            <label> سیستم : </label>
                                            <span ref={tp_system}>{documentItem.tp_system}</span>
                                        </li>
                                        <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                            <label> تیپ : </label>
                                            <span ref={tp_tip}>{documentItem.tp_tip}</span>
                                        </li>
                                        <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                            <label> رنگ : </label>
                                            <span ref={cl_name}>{documentItem.cl_name}</span>
                                        </li>
                                        <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                            <label> مدل : </label>
                                            <span ref={mt_model}>{documentItem.mt_model}</span>
                                        </li>
                                        <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                            <label> شماره بدنه : </label>
                                            <span className="font-style" ref={mt_bodyno}>
                                                {documentItem.mt_bodyno}
                                            </span>
                                            <button type="button" className="rahpardaznet-copy-button"
                                                data-name="شماره بدنه" data-text={documentItem.mt_bodyno}>کپی
                                            </button>

                                        </li>
                                        <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                            <label> شماره انجین : </label>
                                            <span className="font-style" ref={mt_motorno}>
                                                {documentItem.mt_motorno}
                                            </span>

                                            <button type="button" className="rahpardaznet-copy-button"
                                                data-name="شماره انجین" data-text={documentItem.mt_motorno}>کپی
                                            </button>

                                        </li>
                                    </div>
                                    <div className="col-4 col-md-4 p-3 list-group list-group-flush border">
                                        <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                            <label> تعداد محور : </label>
                                            <span ref={tp_mehvar}>{documentItem.tp_mehvar}</span>
                                        </li>
                                        <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                            <label> تعداد چرخ : </label>
                                            <span ref={tp_charkh}>{documentItem.tp_charkh}</span>
                                        </li>
                                        <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                            <label> ظرفیت : </label>
                                            <span ref={tp_zarfiyat}>{documentItem.tp_zarfiyat}</span>
                                        </li>
                                        <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                            <label> تعداد سیلندر : </label>
                                            <span ref={tp_cylandr}>{documentItem.tp_cylandr}</span>
                                        </li>
                                        <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                            <label> نوع سوخت : </label>
                                            <span ref={tp_sookht}>{documentItem.tp_sookht}</span>
                                        </li>
                                        <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                            <label> حجم سیلندر : </label>
                                            <span ref={tp_hajm}>{documentItem.tp_hajm}</span>
                                        </li>
                                    </div>
                                </div>
                                {
                                    (documentItem.saved != 'saved') ? (
                                        <div className='row rahpardaznet-cart my-5 print-position'>
                                            <Header title={'درخواست مشتری'} />
                                            <form onSubmit={customerSearchHandler} className="col-12">
                                                <div className="rahpardaz-search-form-select">

                                                    <select
                                                        value={customerType}
                                                        defaultValue={'nationalCode'}
                                                        className='form-control form-select form-select-lg shadow-none d-none'
                                                        onChange={(e) => setCustomerType(e.target.value)}
                                                        aria-label="form-select-lg example">
                                                        <option value='DEFAULT' selected disabled>یک مورد را انتخاب
                                                            کنید
                                                        </option>
                                                        {/* <option value='mobile'>شماره موبایل</option> */}
                                                        <option value='nationalCode'>شماره ملی</option>

                                                    </select>


                                                    <input
                                                        type="text"
                                                        defaultValue={customerNumber}
                                                        onChange={(e) => setCustomerNumber(e.target.value)}
                                                        id="customerNumber"
                                                        className="form-control  form-control-lg  shadow-none border-right"
                                                        placeholder='کدملی مشتری را وارد نمایید.'
                                                    />

                                                    <button
                                                        onClick={customerSearchHandler}
                                                        type="submit"
                                                        className="print-no rahpardaznet-search-btn">
                                                        {btnFind ? (<div className="spinner-border text-light"
                                                            role="status"></div>) : "جستجوی مشتری "}
                                                        {'   '}

                                                    </button>


                                                </div>
                                                <div>
                                                    {
                                                        (errorCustomerNumber) ? (
                                                            <span className="help-block d-inline-block mt-2">
                                                                <small
                                                                    className='text-danger validate-error'>{errorCustomerNumber}</small>
                                                            </span>
                                                        ) : ''}
                                                </div>
                                                <div>
                                                    {
                                                        (errorCustomerType) ? (
                                                            <span className="help-block d-inline-block mt-2">
                                                                <small
                                                                    className='text-danger validate-error'>{errorCustomerType}</small>
                                                            </span>
                                                        ) : ''}
                                                </div>
                                                <div>
                                                    {
                                                        messeageCustomer ? (
                                                            <Message message={messeageCustomer} />
                                                        ) : null
                                                    }
                                                </div>


                                            </form>
                                        </div>
                                    ) : null
                                }

                                {
                                    (documentItem.saved == "saved" && documentItem.customer_data != null && documentItem.customer_data != []) ? (
                                        <>

                                            <div className='row rahpardaznet-cart  my-5 '>

                                                <Header title={'مشخصات مالک'} />
                                                <div className="col-7 col-md-8 p-3 list-group list-group-flush border">
                                                    <li className="rahpardaznet-list-group-item pb-2 justify-content-start align-items-center d-flex">
                                                        <div> نام نام خانوادگی :</div>
                                                        <span
                                                            className="px-3">{(documentItem.customer_data.name) ? documentItem.customer_data.name : ''} {(documentItem.customer_data.family) ? documentItem.customer_data.family : ''}</span>
                                                    </li>

                                                    <li className="rahpardaznet-list-group-item pt-2 pb-2 justify-content-start align-items-center d-flex">
                                                        <div> نام پدر :</div>
                                                        <span
                                                            className="px-3">{documentItem.customer_data.father_name}</span>
                                                    </li>
                                                    <li className="rahpardaznet-list-group-item pt-2 pb-2 justify-content-start align-items-center d-flex">
                                                        <div> محل ثبت تولد :</div>
                                                        <span
                                                            className="px-3">{documentItem.customer_data.birthplace}</span>
                                                    </li>
                                                    <li className="rahpardaznet-list-group-item pt-2 pb-2 justify-content-start align-items-center d-flex">
                                                        <div> آدرس محل سکونت :</div>
                                                        <span
                                                            className="px-3">{documentItem.customer_data.address}</span>
                                                    </li>
                                                    <li className="rahpardaznet-list-group-item pt-2 pb-2 justify-content-start align-items-center d-flex">
                                                        <div> شماره شناسنامه / ملی:</div>
                                                        <span
                                                            className="px-3">{documentItem.customer_data.nationalCode}</span>
                                                    </li>
                                                    <li className="rahpardaznet-list-group-item  pt-2 pb-2 justify-content-start align-items-center d-flex">
                                                        <div> کد پستی :</div>
                                                        <span className="px-3">
                                                            {documentItem.customer_data.postalcode}
                                                        </span>
                                                    </li>
                                                </div>
                                                <div className="col-5 col-md-4 p-3 list-group list-group-flush border">
                                                    <li className="rahpardaznet-list-group-item pb-2 justify-content-start align-items-center d-flex">
                                                        <div> تاریخ ثبت/تولد :</div>
                                                        <span
                                                            className="px-3">{documentItem.customer_data.birthdaye}</span>
                                                    </li>
                                                    <li className="rahpardaznet-list-group-item  pt-2 pb-2 justify-content-start align-items-center d-flex">
                                                        <div> شماره ثبت/شناسنامه:</div>
                                                        <span
                                                            className="px-3">{documentItem.customer_data.idcard}</span>
                                                    </li>
                                                    <li className="rahpardaznet-list-group-item pt-2 pb-2 justify-content-start align-items-center d-flex">
                                                        <div> ثبت / محل صدور :</div>
                                                        <span
                                                            className="px-3">{documentItem.customer_data.placeofissue}</span>
                                                    </li>
                                                    <li className="rahpardaznet-list-group-item pt-2 pb-2 justify-content-start align-items-center d-flex">
                                                        <div> تلفن ثابت :</div>
                                                        <span className="px-3">{documentItem.customer_data.phone}</span>
                                                    </li>
                                                    <li className="rahpardaznet-list-group-item pt-2 pb-2 justify-content-start align-items-center d-flex">
                                                        <div> شماره موبایل :</div>
                                                        <span className="px-3">
                                                            {documentItem.customer_data.mobile}
                                                        </span>
                                                    </li>
                                                </div>
                                            </div>
                                            <div
                                                className={rk_document_transfer == true && rk_document_transfer != " " ? 'back-success row rahpardaznet-cart  my-5 ' : 'back-danger row rahpardaznet-cart  my-5 '}>
                                                <Header title={'انتقال سند'} />
                                                <div className="col-7 col-md-8 p-3 list-group list-group-flush">
                                                    <div className="rahpadraznet-document-transfer">
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="checkbox" value=""
                                                                id="rahpardaznet-document-transfer"
                                                                checked={rk_document_transfer == true && rk_document_transfer != " " ? 'checked' : null}
                                                                onChange={(e) => setRk_document_transfer(e.target.checked)} />
                                                            <label className="form-check-label"
                                                                htmlFor="rahpardaznet-document-transfer">
                                                                جهت انتقال سند تیک را بزنید.
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {
                                                (rk_document_transfer == true && rk_document_transfer != " ") ? (
                                                    <>
                                                        <div className='rahpardaznet-document-transfer-alert'>
                                                            شما در حال انتقال سند هستید.
                                                        </div>
                                                    </>
                                                ) : null
                                            }

                                            {
                                                (rk_document_transfer == true && rk_document_transfer != " " && rk_owner_validation_status != '1') ? (
                                                    <>


                                                        <div className='row rahpardaznet-cart  my-5 '>

                                                            <Header title={'احراز هویت مالک'} />
                                                            <div className="col-12 p-3 list-group list-group-flush">
                                                                <div className="col-12 col-md-6">
                                                                    <div
                                                                        className='row m-3 d-flex flex-row justify-content-between rahpardaznet-form-controll'>
                                                                        <label htmlFor=
                                                                            "mobile"
                                                                            className="text-end form-label px-1 ">
                                                                            تلفن همراه
                                                                            {
                                                                                (!documentItem.customer_data.mobile) ? (
                                                                                    <span className="text-danger pr-2">(شماره موبایل مالک ثبت نشده است)</span>
                                                                                ) : null
                                                                            }
                                                                        </label>

                                                                        <input
                                                                            type="hidden"
                                                                            disabled
                                                                            value={OwnerHashCode ? OwnerHashCode : null}
                                                                            onChange={(e) => setOwnerHashCodeNumber(e.target.value)}
                                                                            className="form-control shadow-none text-left"
                                                                            id="OwnerHashCode"
                                                                            placeholder=""
                                                                        />
                                                                        <div className='rahpardaznet-form-mobile'>
                                                                            <input
                                                                                disabled={OwnerBtnDisable == '1' ? 'disabled' : false}
                                                                                tabIndex="7"
                                                                                type="text"
                                                                                value={OwnerMobile ? OwnerMobile : documentItem.customer_data.mobile}
                                                                                onChange={(e) => setOwnerMobile(e.target.value)}
                                                                                className=""
                                                                                id="Ownermobile"
                                                                                placeholder="شماره تلفن"
                                                                            />
                                                                            <input
                                                                                disabled={OwnerBtnDisable == '1' ? 'disabled' : false}
                                                                                tabIndex="8"
                                                                                type="text"

                                                                                onChange={(e) => setOwnerVerificationCode(e.target.value)}

                                                                                id="OwnerverificationCode"
                                                                                placeholder="کد تایید"
                                                                            />

                                                                            {
                                                                                (OwnerBtnConfirm != '1') ? (
                                                                                    <button
                                                                                        tabIndex='9'
                                                                                        onClick={OwnerVerificationCodeHandler}
                                                                                        type="submit"
                                                                                        className="print-no">
                                                                                        {OwnerBtnSms == '1' ? (<div
                                                                                            className="spinner-border text-light"
                                                                                            role="status"></div>) : "ارسال"}


                                                                                    </button>
                                                                                ) : (
                                                                                    <button
                                                                                        disabled={OwnerBtnDisable == '1' ? 'disabled' : false}
                                                                                        tabIndex='9'
                                                                                        onClick={OwnerValidationCodeHandler}
                                                                                        type="submit"
                                                                                        className="print-no rahpardaznet-validation">
                                                                                        {OwnerBtnSms == '1' ? (<div
                                                                                            className="spinner-border text-light"
                                                                                            role="status"></div>) : "تایید"}


                                                                                    </button>
                                                                                )

                                                                            }


                                                                        </div>

                                                                        {
                                                                            (OwnerTextValidation == '1') ? (
                                                                                <span
                                                                                    className="help-block d-inline-block mt-2 mr-0 pr-0">
                                                                                    <small className='text-success'>شماره موبایل مالک با موفقیت اعتبار سنجی شد.</small>
                                                                                </span>
                                                                            ) : ''}

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : null

                                            }
                                            {
                                                (rk_document_transfer == true && rk_document_transfer != " " && rk_owner_validation_status == '1') ? (
                                                    <>
                                                        <div className='row rahpardaznet-cart my-5 print-position'>
                                                            <Header title={'درخواست مشتری'} />
                                                            <div className="col-12">
                                                                <div className="rahpardaz-search-form-select">

                                                                    <select
                                                                        value={customerType}
                                                                        defaultValue={'nationalCode'}
                                                                        className='form-control form-select form-select-lg shadow-none d-none'
                                                                        onChange={(e) => setCustomerType(e.target.value)}
                                                                        aria-label="form-select-lg example">
                                                                        <option value='DEFAULT' selected disabled>یک
                                                                            مورد را انتخاب کنید
                                                                        </option>
                                                                        {/* <option value='mobile'>شماره موبایل</option> */}
                                                                        <option value='nationalCode'>شماره ملی</option>

                                                                    </select>


                                                                    <input
                                                                        type="text"
                                                                        defaultValue={customerNumber}
                                                                        onChange={(e) => setCustomerNumber(e.target.value)}
                                                                        id="customerNumber"
                                                                        className="form-control  form-control-lg  shadow-none border-right"
                                                                        placeholder='کدملی مشتری را وارد نمایید.'
                                                                    />

                                                                    <button
                                                                        onClick={customerSearchHandler}
                                                                        type="submit"
                                                                        className="print-no rahpardaznet-search-btn">
                                                                        {btnFind ? (
                                                                            <div className="spinner-border text-light"
                                                                                role="status"></div>) : "جستجوی مشتری "}
                                                                        {'   '}

                                                                    </button>

                                                                </div>
                                                                <div>
                                                                    {
                                                                        (errorCustomerNumber) ? (
                                                                            <span
                                                                                className="help-block d-inline-block mt-2">
                                                                                <small
                                                                                    className='text-danger validate-error'>{errorCustomerNumber}</small>
                                                                            </span>
                                                                        ) : ''}
                                                                </div>
                                                                <div>
                                                                    {
                                                                        (errorCustomerType) ? (
                                                                            <span
                                                                                className="help-block d-inline-block mt-2">
                                                                                <small
                                                                                    className='text-danger validate-error'>{errorCustomerType}</small>
                                                                            </span>
                                                                        ) : ''}
                                                                </div>
                                                                <div>
                                                                    {
                                                                        messeageCustomer ? (
                                                                            <Message message={messeageCustomer} />
                                                                        ) : null
                                                                    }
                                                                </div>


                                                            </div>
                                                        </div>
                                                        {
                                                            (boxCustomer == '1') ? (
                                                                <>
                                                                    <div className='row rahpardaznet-cart  my-5 '>
                                                                        <Header title={'مشخصات خریدار'} />
                                                                        <>
                                                                            <form>
                                                                                <div className="row">
                                                                                    <div className="col-12 col-md-6 ">
                                                                                        <div
                                                                                            className="row m-3 rahpardaznet-form-controll">
                                                                                            <label htmlFor=""
                                                                                                className="text-end form-label px-1 ">
                                                                                                نام
                                                                                            </label>
                                                                                            <input
                                                                                                tabIndex="3"
                                                                                                type="text"
                                                                                                value={name ? name : null}
                                                                                                onChange={(e) => setName(e.target.value)}
                                                                                                className="form-control shadow-none"
                                                                                                id=""
                                                                                                placeholder=""
                                                                                                autoFocus
                                                                                            />
                                                                                            {
                                                                                                (errorName) ? (
                                                                                                    <span
                                                                                                        className="help-block d-inline-block mt-2">
                                                                                                        <small
                                                                                                            className='text-danger validate-error'>{errorName}</small>
                                                                                                    </span>
                                                                                                ) : ''}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-12 col-md-6">
                                                                                        <div
                                                                                            className="row m-3 rahpardaznet-form-controll">
                                                                                            <label htmlFor=""
                                                                                                className="text-end form-label px-1 ">
                                                                                                نام خانوادگی
                                                                                            </label>
                                                                                            <input
                                                                                                tabIndex="4"
                                                                                                type="text"
                                                                                                value={family ? family : null}
                                                                                                onChange={(e) => setFamily(e.target.value)}
                                                                                                className="form-control shadow-none"
                                                                                                id=""
                                                                                                placeholder=""
                                                                                            />
                                                                                            {
                                                                                                (errorFamily) ? (
                                                                                                    <span
                                                                                                        className="help-block d-inline-block mt-2">
                                                                                                        <small
                                                                                                            className='text-danger validate-error'>{errorFamily}</small>
                                                                                                    </span>
                                                                                                ) : ''}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-12 col-md-6">
                                                                                        <div
                                                                                            className="row m-3 rahpardaznet-form-controll">
                                                                                            <label htmlFor="father_name"
                                                                                                className="text-end form-label px-1 ">
                                                                                                نام پدر
                                                                                            </label>
                                                                                            <input
                                                                                                tabIndex="5"
                                                                                                type="text"
                                                                                                value={father_name ? father_name : null}
                                                                                                onChange={(e) => setFatherName(e.target.value)}
                                                                                                className="form-control shadow-none"
                                                                                                id="father_name"
                                                                                                placeholder=""
                                                                                            />
                                                                                            {
                                                                                                (errorfather_name) ? (
                                                                                                    <span
                                                                                                        className="help-block d-inline-block mt-2">
                                                                                                        <small
                                                                                                            className='text-danger validate-error'>{errorfather_name}</small>
                                                                                                    </span>
                                                                                                ) : ''}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-12 col-md-6">
                                                                                        <div
                                                                                            className="row m-3 rahpardaznet-form-controll">
                                                                                            <label
                                                                                                htmlFor="nationalCode"
                                                                                                className="text-end form-label px-1 ">
                                                                                                شماره/شناسه ملی
                                                                                            </label>
                                                                                            <input
                                                                                                disabled
                                                                                                tabIndex="6"
                                                                                                type="text"
                                                                                                value={customerNumber ? customerNumber : null}
                                                                                                // onChange={(e) => setNationalCode(e.target.value)}
                                                                                                className="form-control shadow-none text-left"
                                                                                                id="nationalCode"
                                                                                                placeholder=""
                                                                                            />
                                                                                            {
                                                                                                (errorNationalCode) ? (
                                                                                                    <span
                                                                                                        className="help-block d-inline-block mt-2">
                                                                                                        <small
                                                                                                            className='text-danger validate-error'>{errorNationalCode}</small>
                                                                                                    </span>
                                                                                                ) : ''}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-12 col-md-6">
                                                                                        <div
                                                                                            className='row m-3 d-flex flex-row justify-content-between rahpardaznet-form-controll'>
                                                                                            <label htmlFor="mobile"
                                                                                                className="text-end form-label px-1 d-flex justify-content-between">
                                                                                                تلفن همراه
                                                                                            </label>
                                                                                            <input
                                                                                                type="hidden"
                                                                                                disabled
                                                                                                value={HashCode ? HashCode : null}
                                                                                                onChange={(e) => setHashCodeNumber(e.target.value)}
                                                                                                className="form-control shadow-none text-left"
                                                                                                id="HashCode"
                                                                                                placeholder=""
                                                                                            />
                                                                                            <div
                                                                                                className='rahpardaznet-form-mobile'>
                                                                                                <input
                                                                                                    disabled={btnDisable == '1' ? 'disabled' : false}
                                                                                                    tabIndex="7"
                                                                                                    type="text"
                                                                                                    value={mobile ? mobile : null}
                                                                                                    onChange={(e) => setMobile(e.target.value)}
                                                                                                    className=""
                                                                                                    id="mobile"
                                                                                                    placeholder="شماره تلفن"
                                                                                                />
                                                                                                <input
                                                                                                    disabled={btnDisable == '1' ? 'disabled' : false}
                                                                                                    tabIndex="8"
                                                                                                    type="text"
                                                                                                    value={verificationCode ? verificationCode : null}
                                                                                                    onChange={(e) => setVerificationCode(e.target.value)}
                                                                                                    id="verificationCode"
                                                                                                    placeholder="کد تایید"
                                                                                                />

                                                                                                {
                                                                                                    (btnConfirm != '1') ? (
                                                                                                        <button
                                                                                                            tabIndex='9'
                                                                                                            onClick={verivicationCodeHandler}
                                                                                                            type="submit"
                                                                                                            className="print-no">
                                                                                                            {btnSms == '1' ? (
                                                                                                                <div
                                                                                                                    className="spinner-border text-light"
                                                                                                                    role="status"></div>) : "ارسال"}


                                                                                                        </button>
                                                                                                    ) : (
                                                                                                        <button
                                                                                                            disabled={btnDisable == '1' ? 'disabled' : false}
                                                                                                            tabIndex='9'
                                                                                                            onClick={validationCodeHandler}
                                                                                                            type="submit"
                                                                                                            className="print-no rahpardaznet-validation">
                                                                                                            {
                                                                                                                btnSms == '1' && (
                                                                                                                    <div
                                                                                                                        className="spinner-border text-light"
                                                                                                                        role="status"></div>)
                                                                                                                || btnSms == '2' && "تایید شده"
                                                                                                                || "تایید"
                                                                                                            }


                                                                                                        </button>
                                                                                                    )

                                                                                                }


                                                                                            </div>

                                                                                            {
                                                                                                (TextValidation == '1') ? (
                                                                                                    <span
                                                                                                        className="help-block d-inline-block mt-2 mr-0 pr-0">
                                                                                                        <small
                                                                                                            className='text-success'>شماره موبایل خریدار با موفقیت اعتبار سنجی شد.</small>
                                                                                                    </span>
                                                                                                ) : ''}

                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-12 col-md-6">
                                                                                        <div
                                                                                            className="row m-3 rahpardaznet-form-controll">
                                                                                            <label htmlFor="phone"
                                                                                                className="text-end form-label px-1 ">
                                                                                                تلفن
                                                                                            </label>
                                                                                            <input
                                                                                                tabIndex="10"
                                                                                                type="text"
                                                                                                value={phone ? phone : null}
                                                                                                onChange={(e) => setPhone(e.target.value)}
                                                                                                className="form-control shadow-none text-left"
                                                                                                id="phone"
                                                                                                placeholder=""
                                                                                            />
                                                                                            {
                                                                                                (errorPhone) ? (
                                                                                                    <span
                                                                                                        className="help-block d-inline-block mt-2">
                                                                                                        <small
                                                                                                            className='text-danger validate-error'>{errorPhone}</small>
                                                                                                    </span>
                                                                                                ) : ''}
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-12 col-md-6">
                                                                                        <div
                                                                                            className="row m-3 rahpardaznet-form-controll">
                                                                                            <label htmlFor="birthplace"
                                                                                                className="text-end form-label px-1 ">
                                                                                                محل تولد
                                                                                            </label>
                                                                                            <input
                                                                                                tabIndex="11"
                                                                                                type="text"
                                                                                                value={birthplace ? birthplace : null}
                                                                                                onChange={(e) => setBirthplace(e.target.value)}
                                                                                                className="form-control shadow-none"
                                                                                                id="birthplace"
                                                                                                placeholder=""
                                                                                            />
                                                                                            {
                                                                                                (errorBirthplace) ? (
                                                                                                    <span
                                                                                                        className="help-block d-inline-block mt-2">
                                                                                                        <small
                                                                                                            className='text-danger validate-error'>{errorBirthplace}</small>
                                                                                                    </span>
                                                                                                ) : ''}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-12 col-md-6">
                                                                                        <div
                                                                                            className="row m-3 rahpardaznet-form-controll">
                                                                                            <label htmlFor="birthdaye"
                                                                                                className="text-end form-label px-1 ">
                                                                                                تاریخ تولد
                                                                                            </label>


                                                                                            <input
                                                                                                tabIndex="12"
                                                                                                type="text"
                                                                                                value={birthdaye ? birthdaye : null}
                                                                                                onChange={(e) => setbirthdaye(e.target.value)}
                                                                                                className="form-control shadow-none  text-left"
                                                                                                id="birthdaye"
                                                                                                placeholder=""
                                                                                            />
                                                                                            <div>

                                                                                            </div>
                                                                                            {
                                                                                                (errorbirthdaye) ? (
                                                                                                    <span
                                                                                                        className="help-block d-inline-block mt-2">
                                                                                                        <small
                                                                                                            className='text-danger validate-error'>{errorbirthdaye}</small>
                                                                                                    </span>
                                                                                                ) : ''}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-12 col-md-6">
                                                                                        <div
                                                                                            className="row m-3 rahpardaznet-form-controll">
                                                                                            <label htmlFor="idcard"
                                                                                                className="text-end form-label px-1 ">
                                                                                                شماره شناسنامه / ثبت
                                                                                            </label>
                                                                                            <input
                                                                                                tabIndex="13"
                                                                                                type="number"
                                                                                                value={idcard ? idcard : null}
                                                                                                onChange={(e) => setIdcard(e.target.value)}
                                                                                                className="form-control shadow-none  text-left"
                                                                                                id="idcard"
                                                                                                placeholder=""
                                                                                            />
                                                                                            {
                                                                                                (errorIdcard) ? (
                                                                                                    <span
                                                                                                        className="help-block d-inline-block mt-2">
                                                                                                        <small
                                                                                                            className='text-danger validate-error'>{errorIdcard}</small>
                                                                                                    </span>
                                                                                                ) : ''}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-12 col-md-6">
                                                                                        <div
                                                                                            className="row m-3 rahpardaznet-form-controll">
                                                                                            <label htmlFor="father_name"
                                                                                                className="text-end form-label px-1 ">
                                                                                                محل صدور
                                                                                            </label>
                                                                                            <input
                                                                                                tabIndex="14"
                                                                                                type="text"
                                                                                                value={placeofissue ? placeofissue : null}
                                                                                                onChange={(e) => setPlaceofissue(e.target.value)}
                                                                                                className="form-control shadow-none"
                                                                                                id="father_name"
                                                                                                placeholder=""
                                                                                            />
                                                                                            {
                                                                                                (errorPlaceofissue) ? (
                                                                                                    <span
                                                                                                        className="help-block d-inline-block mt-2">
                                                                                                        <small
                                                                                                            className='text-danger validate-error'>{errorPlaceofissue}</small>
                                                                                                    </span>
                                                                                                ) : ''}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-12 col-md-6">
                                                                                        <div
                                                                                            className="row m-3 rahpardaznet-form-controll">
                                                                                            <label htmlFor="postalcode"
                                                                                                className="text-end form-label px-1 ">
                                                                                                کد پستی
                                                                                            </label>
                                                                                            <input
                                                                                                tabIndex="15"
                                                                                                type="number"
                                                                                                value={postalcode ? postalcode : null}
                                                                                                onChange={(e) => setPostalcode(e.target.value)}
                                                                                                className="form-control shadow-none  text-left"
                                                                                                id="postalcode"
                                                                                                placeholder=""
                                                                                            />
                                                                                            {
                                                                                                (errorPostalcode) ? (
                                                                                                    <span
                                                                                                        className="help-block d-inline-block mt-2">
                                                                                                        <small
                                                                                                            className='text-danger validate-error'>{errorPostalcode}</small>
                                                                                                    </span>
                                                                                                ) : ''}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className='col-12 col-md-6'>
                                                                                        <div
                                                                                            className="row m-3 rahpardaznet-form-controll">
                                                                                            <label htmlFor="address"
                                                                                                className="text-end form-label px-1 ">
                                                                                                آدرس محل سکونت
                                                                                            </label>
                                                                                            <input
                                                                                                tabIndex="16"
                                                                                                type="text"
                                                                                                value={address ? address : null}
                                                                                                onChange={(e) => setAddress(e.target.value)}
                                                                                                className="form-control shadow-none"
                                                                                                id="address"
                                                                                                placeholder=""
                                                                                            />
                                                                                            {
                                                                                                (errorAddress) ? (
                                                                                                    <span
                                                                                                        className="help-block d-inline-block mt-2">
                                                                                                        <small
                                                                                                            className='text-danger validate-error'>{errorAddress}</small>
                                                                                                    </span>
                                                                                                ) : ''}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </form>
                                                                        </>
                                                                    </div>
                                                                    <div
                                                                        className='row rahpardaznet-cart  my-5  print-position'>
                                                                        <Header title={'دریافت مدارک'} />
                                                                        <div className="col-12">
                                                                            <div
                                                                                className="form-check rahpdrdaznet-border-bottom">
                                                                                <input className="form-check-input"
                                                                                    type="checkbox" value=""
                                                                                    id="flexCheckIndeterminate"
                                                                                    onChange={(e) => setRk_birth_certificate(e.target.checked)} />
                                                                                {
                                                                                    (rk_birth_certificate == true) ? (
                                                                                        <label
                                                                                            className="form-check-label text-success"
                                                                                            htmlFor="flexCheckIndeterminate">شناسنامه
                                                                                            دریافت شده است.</label>
                                                                                    ) : (
                                                                                        <label
                                                                                            className="form-check-label text-danger"
                                                                                            htmlFor="flexCheckIndeterminate">شناسنامه
                                                                                            دریافت نشده است.</label>

                                                                                    )
                                                                                }
                                                                            </div>
                                                                            <div
                                                                                className="form-check rahpdrdaznet-border-bottom">
                                                                                <input className="form-check-input"
                                                                                    type="checkbox" value=""
                                                                                    id="rahpardaznet-national-card"
                                                                                    onChange={(e) => setRk_national_card(e.target.checked)} />
                                                                                {
                                                                                    (rk_national_card == true) ? (
                                                                                        <label
                                                                                            className="form-check-label text-success"
                                                                                            htmlFor="rahpardaznet-national-card">کارت
                                                                                            ملی دریافت شده است.</label>
                                                                                    ) : (
                                                                                        <label
                                                                                            className="form-check-label text-danger"
                                                                                            htmlFor="rahpardaznet-national-card">کارت
                                                                                            ملی دریافت نشده است.</label>

                                                                                    )
                                                                                }
                                                                            </div>
                                                                            <div
                                                                                className="form-check rahpdrdaznet-border-bottom">
                                                                                <input className="form-check-input"
                                                                                    type="checkbox" value=""
                                                                                    id="rahpardaznet-policy"
                                                                                    onChange={(e) => setRk_policy(e.target.checked)} />
                                                                                {
                                                                                    (rk_policy == true) ? (
                                                                                        <label
                                                                                            className="form-check-label text-success"
                                                                                            htmlFor="rahpardaznet-policy">بیمه
                                                                                            نامه دریافت شده است.</label>
                                                                                    ) : (
                                                                                        <label
                                                                                            className="form-check-label text-danger"
                                                                                            htmlFor="rahpardaznet-policy">بیمه
                                                                                            نامه دریافت نشده
                                                                                            است.</label>

                                                                                    )
                                                                                }
                                                                            </div>
                                                                            <div
                                                                                className="form-check rahpdrdaznet-border-bottom">
                                                                                <input className="form-check-input"
                                                                                    type="checkbox" value=""
                                                                                    id="rahpardaznet-residence-verification"
                                                                                    onChange={(e) => setRk_residence_verification(e.target.checked)} />
                                                                                {
                                                                                    (rk_residence_verification == true) ? (
                                                                                        <label
                                                                                            className="form-check-label text-success"
                                                                                            htmlFor="rahpardaznet-residence-verification">احراز
                                                                                            سکونت دریافت شده
                                                                                            است.</label>
                                                                                    ) : (
                                                                                        <label
                                                                                            className="form-check-label text-danger"
                                                                                            htmlFor="rahpardaznet-residence-verification">احراز
                                                                                            سکونت دریافت نشده
                                                                                            است.</label>

                                                                                    )
                                                                                }
                                                                            </div>
                                                                            <div
                                                                                className="form-check rahpdrdaznet-border-bottom">
                                                                                <input className="form-check-input"
                                                                                    type="checkbox" value=""
                                                                                    id="rahpardaznet-receipt"
                                                                                    onChange={(e) => setRk_receipt(e.target.checked)} />
                                                                                {
                                                                                    (rk_receipt == true) ? (
                                                                                        <label
                                                                                            className="form-check-label text-success"
                                                                                            htmlFor="rahpardaznet-receipt">فیش
                                                                                            قبض دریافت شده است.</label>

                                                                                    ) : (
                                                                                        <label
                                                                                            className="form-check-label text-danger"
                                                                                            htmlFor="rahpardaznet-receipt">فیش
                                                                                            قبض دریافت نشده است.</label>

                                                                                    )
                                                                                }
                                                                            </div>
                                                                        </div>

                                                                        {
                                                                            (rk_birth_certificate == true && rk_national_card == true && rk_policy == true && rk_residence_verification == true && rk_receipt == true) ? (
                                                                                <div className="col-12 pt-3">

                                                                                    <p className='alert alert-success'>تمامی
                                                                                        مدارک دریافت شده اند.</p>
                                                                                </div>
                                                                            ) : ''}


                                                                    </div>


                                                                    {/* <div className='row rahpardaznet-cart  my-5  print-position'>
    <Header title={'وضعیت سند'} />
    <div className="col-12  d-flex" >
        {
        statuses.length > 0 ? (

        statuses.map((row, key) => (
        (rahkarpardaznet_document_status == row.id) ? (
        <button className='rahpardaznet-document-change-status active m-2' key={key} id={row.id} disabled >
            {row.name}
        </button>
        ) : (
        <button className='rahpardaznet-document-change-status m-2' key={key} id={row.id}
                onClick={(e) => documentStatusUpdateHandler(row.id)} >
        {row.name}
        </button>
        )

        ))
        ) : null
        }
    </div>
</div> */}

                                                                    {/* <div className='row rahpardaznet-cart my-5 print-position'>
    <Header title={'بایگانی سند'}/>
    <div className="col-6 ">
        <Select
                multiple={false}
                key='23'
                tab='23'
                col='col-12'
                name=''
                title='انتقال به انبار'
                value={transferToStore}
                onchange={(e) => transferStoreHandler(e.target.value)}
        status='1'
        data={archives}
        defaultValue={documentItem.store_id}

        />
        <Select
                multiple={false}
                key='24'
                tab='24'
                col='col-12'
                name=''
                title='طبقه بندی رده اول'
                value={partone}
                onchange={(e) => sectionOneSearchHandler(e.target.value)}
        status='1'
        target='1'
        data={sections}
        />
    </div>
    <div className="col-6 ">
        <Select
                multiple={false}
                key='25'
                tab='25'
                col='col-12'
                name=''
                title='طبقه بندی رده دوم'
                value={parttwo}
                onchange={(e) => sectionTwoSearchHandler(e.target.value)}
        status='1'
        target='1'
        data={partOne}
        />
        <Select
                multiple={false}
                key='26'
                tab='26'
                col='col-12'
                name=''
                title='طبقه بندی رده سوم'
                value={partthree}
                onchange={(e) => setPartthree(e.target.value)}
        status='1'
        data={partTwo}
        />
    </div>
</div> */}
                                                                </>
                                                            ) : null

                                                        }
                                                    </>
                                                ) : null
                                            }


                                        </>
                                    ) : null
                                }
                            </>
                        ) : null
                    ) : null
                }
                {

                    (documentItem.saved != "saved" && boxCustomer == '1') ? (
                        (documentItem && typeof documentItem === 'object') ? (
                            (Object.keys(documentItem).length > 0) ? (
                                <>
                                    <div className='row rahpardaznet-cart  my-5 '>
                                        <Header title={'مشخصات خریدار'} />
                                        <>
                                            <form>
                                                <div className="row">
                                                    <div className="col-12 col-md-6 ">
                                                        <div className="row m-3 rahpardaznet-form-controll">
                                                            <label htmlFor="" className="text-end form-label px-1 ">
                                                                نام
                                                            </label>
                                                            <input
                                                                tabIndex="3"
                                                                type="text"
                                                                value={name ? name : null}
                                                                onChange={(e) => setName(e.target.value)}
                                                                className="form-control shadow-none"
                                                                id=""
                                                                placeholder=""
                                                                autoFocus
                                                            />
                                                            {
                                                                (errorName) ? (
                                                                    <span className="help-block d-inline-block mt-2">
                                                                        <small
                                                                            className='text-danger validate-error'>{errorName}</small>
                                                                    </span>
                                                                ) : ''}
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        <div className="row m-3 rahpardaznet-form-controll">
                                                            <label htmlFor="" className="text-end form-label px-1 ">
                                                                نام خانوادگی
                                                            </label>
                                                            <input
                                                                tabIndex="4"
                                                                type="text"
                                                                value={family ? family : null}
                                                                onChange={(e) => setFamily(e.target.value)}
                                                                className="form-control shadow-none"
                                                                id=""
                                                                placeholder=""
                                                            />
                                                            {
                                                                (errorFamily) ? (
                                                                    <span className="help-block d-inline-block mt-2">
                                                                        <small
                                                                            className='text-danger validate-error'>{errorFamily}</small>
                                                                    </span>
                                                                ) : ''}
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        <div className="row m-3 rahpardaznet-form-controll">
                                                            <label htmlFor="father_name"
                                                                className="text-end form-label px-1 ">
                                                                نام پدر
                                                            </label>
                                                            <input
                                                                tabIndex="5"
                                                                type="text"
                                                                value={father_name ? father_name : null}
                                                                onChange={(e) => setFatherName(e.target.value)}
                                                                className="form-control shadow-none"
                                                                id="father_name"
                                                                placeholder=""
                                                            />
                                                            {
                                                                (errorfather_name) ? (
                                                                    <span className="help-block d-inline-block mt-2">
                                                                        <small
                                                                            className='text-danger validate-error'>{errorfather_name}</small>
                                                                    </span>
                                                                ) : ''}
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        <div className="row m-3 rahpardaznet-form-controll">
                                                            <label htmlFor="nationalCode"
                                                                className="text-end form-label px-1 ">
                                                                شماره/شناسه ملی
                                                            </label>
                                                            <input
                                                                disabled
                                                                tabIndex="6"
                                                                type="text"
                                                                value={customerNumber ? customerNumber : null}
                                                                // onChange={(e) => setNationalCode(e.target.value)}
                                                                className="form-control shadow-none text-left"
                                                                id="nationalCode"
                                                                placeholder=""
                                                            />
                                                            {
                                                                (errorNationalCode) ? (
                                                                    <span className="help-block d-inline-block mt-2">
                                                                        <small
                                                                            className='text-danger validate-error'>{errorNationalCode}</small>
                                                                    </span>
                                                                ) : ''}
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        <div
                                                            className='row m-3 d-flex flex-row justify-content-between rahpardaznet-form-controll'>
                                                            <label htmlFor="mobile"
                                                                className="text-end form-label px-1 d-flex justify-content-between">
                                                                تلفن همراه
                                                            </label>

                                                            <div className='background-transparent'>
                                                                <input className="form-check-input" type="checkbox" value=""
                                                                    id="rahpardaznet-buyer-mobile-validation"
                                                                    onChange={(e) => setRk_buyer_mobile_validation(e.target.checked)} />
                                                                <label className="form-check-label"
                                                                    htmlFor="rahpardaznet-receipt">اعتبار سنجی شماره
                                                                    موبایل خریدار</label>
                                                            </div>
                                                            {
                                                                (rk_buyer_mobile_validation == '1') ? (
                                                                    <>
                                                                        <input
                                                                            type="hidden"
                                                                            disabled
                                                                            value={HashCode ? HashCode : null}
                                                                            onChange={(e) => setHashCodeNumber(e.target.value)}
                                                                            className="form-control shadow-none text-left"
                                                                            id="HashCode"
                                                                            placeholder=""
                                                                        />
                                                                        <div className='rahpardaznet-form-mobile'>
                                                                            <input
                                                                                disabled={btnDisable == '1' ? 'disabled' : false}
                                                                                tabIndex="7"
                                                                                type="text"
                                                                                value={mobile ? mobile : null}
                                                                                onChange={(e) => setMobile(e.target.value)}
                                                                                className=""
                                                                                id="mobile"
                                                                                placeholder="شماره تلفن"
                                                                            />
                                                                            <input
                                                                                disabled={btnDisable == '1' ? 'disabled' : false}
                                                                                tabIndex="8"
                                                                                type="text"
                                                                                value={verificationCode ? verificationCode : null}
                                                                                onChange={(e) => setVerificationCode(e.target.value)}

                                                                                id="verificationCode"
                                                                                placeholder="کد تایید"
                                                                            />

                                                                            {
                                                                                (btnConfirm != '1') ? (
                                                                                    <button
                                                                                        tabIndex='9'
                                                                                        onClick={verivicationCodeHandler}
                                                                                        type="submit"
                                                                                        className="print-no">
                                                                                        {btnSms == '1' ? (<div
                                                                                            className="spinner-border text-light"
                                                                                            role="status"></div>) : "ارسال"}


                                                                                    </button>
                                                                                ) : (
                                                                                    <button
                                                                                        disabled={btnDisable == '1' ? 'disabled' : false}
                                                                                        tabIndex='9'
                                                                                        onClick={validationCodeHandler}
                                                                                        type="submit"
                                                                                        className="print-no rahpardaznet-validation">
                                                                                        {
                                                                                            btnSms == '1' && (<div
                                                                                                className="spinner-border text-light"
                                                                                                role="status"></div>)
                                                                                            || btnSms == '2' && "تایید شده"
                                                                                            || "تایید"
                                                                                        }


                                                                                    </button>
                                                                                )

                                                                            }


                                                                        </div>

                                                                        {
                                                                            (TextValidation == '1') ? (
                                                                                <span
                                                                                    className="help-block d-inline-block mt-2 mr-0 pr-0">
                                                                                    <small className='text-success'>شماره موبایل خریدار با موفقیت اعتبار سنجی شد.</small>
                                                                                </span>
                                                                            ) : ''
                                                                        }
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <div className='rahpardaznet-form-controll'>
                                                                            <input
                                                                                tabIndex="7"
                                                                                type="text"
                                                                                value={mobile ? mobile : null}
                                                                                onChange={(e) => setMobile(e.target.value)}
                                                                                className="form-control shadow-none text-left"
                                                                                id="mobile"
                                                                                placeholder="شماره تلفن"
                                                                            />

                                                                        </div>
                                                                    </>
                                                                )
                                                            }


                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        <div className="row m-3 rahpardaznet-form-controll">
                                                            <label htmlFor="phone"
                                                                className="text-end form-label px-1 ">
                                                                تلفن
                                                            </label>
                                                            <input
                                                                tabIndex="10"
                                                                type="text"
                                                                value={phone ? phone : null}
                                                                onChange={(e) => setPhone(e.target.value)}
                                                                className="form-control shadow-none text-left"
                                                                id="phone"
                                                                placeholder=""
                                                            />
                                                            {
                                                                (errorPhone) ? (
                                                                    <span className="help-block d-inline-block mt-2">
                                                                        <small
                                                                            className='text-danger validate-error'>{errorPhone}</small>
                                                                    </span>
                                                                ) : ''}
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-md-6">
                                                        <div className="row m-3 rahpardaznet-form-controll">
                                                            <label htmlFor="birthplace"
                                                                className="text-end form-label px-1 ">
                                                                محل تولد
                                                            </label>
                                                            <input
                                                                tabIndex="11"
                                                                type="text"
                                                                value={birthplace ? birthplace : null}
                                                                onChange={(e) => setBirthplace(e.target.value)}
                                                                className="form-control shadow-none"
                                                                id="birthplace"
                                                                placeholder=""
                                                            />
                                                            {
                                                                (errorBirthplace) ? (
                                                                    <span className="help-block d-inline-block mt-2">
                                                                        <small
                                                                            className='text-danger validate-error'>{errorBirthplace}</small>
                                                                    </span>
                                                                ) : ''}
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        <div className="row m-3 rahpardaznet-form-controll">
                                                            <label htmlFor="birthdaye"
                                                                className="text-end form-label px-1 ">
                                                                تاریخ تولد
                                                            </label>


                                                            <input
                                                                tabIndex="12"
                                                                type="text"
                                                                value={birthdaye ? birthdaye : null}
                                                                onChange={(e) => setbirthdaye(e.target.value)}
                                                                className="form-control shadow-none  text-left"
                                                                id="birthdaye"
                                                                placeholder=""
                                                            />
                                                            <div>

                                                            </div>
                                                            {
                                                                (errorbirthdaye) ? (
                                                                    <span className="help-block d-inline-block mt-2">
                                                                        <small
                                                                            className='text-danger validate-error'>{errorbirthdaye}</small>
                                                                    </span>
                                                                ) : ''}
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        <div className="row m-3 rahpardaznet-form-controll">
                                                            <label htmlFor="idcard"
                                                                className="text-end form-label px-1 ">
                                                                شماره شناسنامه / ثبت
                                                            </label>
                                                            <input
                                                                tabIndex="13"
                                                                type="number"
                                                                value={idcard ? idcard : null}
                                                                onChange={(e) => setIdcard(e.target.value)}
                                                                className="form-control shadow-none  text-left"
                                                                id="idcard"
                                                                placeholder=""
                                                            />
                                                            {
                                                                (errorIdcard) ? (
                                                                    <span className="help-block d-inline-block mt-2">
                                                                        <small
                                                                            className='text-danger validate-error'>{errorIdcard}</small>
                                                                    </span>
                                                                ) : ''}
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        <div className="row m-3 rahpardaznet-form-controll">
                                                            <label htmlFor="father_name"
                                                                className="text-end form-label px-1 ">
                                                                محل صدور
                                                            </label>
                                                            <input
                                                                tabIndex="14"
                                                                type="text"
                                                                value={placeofissue ? placeofissue : null}
                                                                onChange={(e) => setPlaceofissue(e.target.value)}
                                                                className="form-control shadow-none"
                                                                id="father_name"
                                                                placeholder=""
                                                            />
                                                            {
                                                                (errorPlaceofissue) ? (
                                                                    <span className="help-block d-inline-block mt-2">
                                                                        <small
                                                                            className='text-danger validate-error'>{errorPlaceofissue}</small>
                                                                    </span>
                                                                ) : ''}
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        <div className="row m-3 rahpardaznet-form-controll">
                                                            <label htmlFor="postalcode"
                                                                className="text-end form-label px-1 ">
                                                                کد پستی
                                                            </label>
                                                            <input
                                                                tabIndex="15"
                                                                type="number"
                                                                value={postalcode ? postalcode : null}
                                                                onChange={(e) => setPostalcode(e.target.value)}
                                                                className="form-control shadow-none  text-left"
                                                                id="postalcode"
                                                                placeholder=""
                                                            />
                                                            {
                                                                (errorPostalcode) ? (
                                                                    <span className="help-block d-inline-block mt-2">
                                                                        <small
                                                                            className='text-danger validate-error'>{errorPostalcode}</small>
                                                                    </span>
                                                                ) : ''}
                                                        </div>
                                                    </div>
                                                    <div className='col-12 col-md-6'>
                                                        <div className="row m-3 rahpardaznet-form-controll">
                                                            <label htmlFor="address"
                                                                className="text-end form-label px-1 ">
                                                                آدرس محل سکونت
                                                            </label>
                                                            <input
                                                                tabIndex="16"
                                                                type="text"
                                                                value={address ? address : null}
                                                                onChange={(e) => setAddress(e.target.value)}
                                                                className="form-control shadow-none"
                                                                id="address"
                                                                placeholder=""
                                                            />
                                                            {
                                                                (errorAddress) ? (
                                                                    <span className="help-block d-inline-block mt-2">
                                                                        <small
                                                                            className='text-danger validate-error'>{errorAddress}</small>
                                                                    </span>
                                                                ) : ''}
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </>
                                    </div>
                                    <div className='row rahpardaznet-cart  my-5  print-position'>
                                        <Header title={'دریافت مدارک'} />
                                        <div className="col-12">
                                            <div className="form-check rahpdrdaznet-border-bottom">
                                                <input tabIndex="17" className="form-check-input" type="checkbox" value=""
                                                    id="flexCheckIndeterminate"
                                                    onChange={(e) => setRk_birth_certificate(e.target.checked)} />
                                                {
                                                    (rk_birth_certificate == true) ? (
                                                        <label className="form-check-label text-success"
                                                            htmlFor="flexCheckIndeterminate">شناسنامه دریافت شده
                                                            است.</label>
                                                    ) : (
                                                        <label className="form-check-label text-danger"
                                                            htmlFor="flexCheckIndeterminate">شناسنامه دریافت نشده
                                                            است.</label>

                                                    )
                                                }
                                            </div>
                                            <div className="form-check rahpdrdaznet-border-bottom">
                                                <input tabIndex="18" className="form-check-input" type="checkbox" value=""
                                                    id="rahpardaznet-national-card"
                                                    onChange={(e) => setRk_national_card(e.target.checked)} />
                                                {
                                                    (rk_national_card == true) ? (
                                                        <label className="form-check-label text-success"
                                                            htmlFor="rahpardaznet-national-card">کارت ملی دریافت شده
                                                            است.</label>
                                                    ) : (
                                                        <label className="form-check-label text-danger"
                                                            htmlFor="rahpardaznet-national-card">کارت ملی دریافت نشده
                                                            است.</label>

                                                    )
                                                }
                                            </div>
                                            <div className="form-check rahpdrdaznet-border-bottom">
                                                <input tabIndex="19" className="form-check-input" type="checkbox" value=""
                                                    id="rahpardaznet-policy"
                                                    onChange={(e) => setRk_policy(e.target.checked)} />
                                                {
                                                    (rk_policy == true) ? (
                                                        <label className="form-check-label text-success"
                                                            htmlFor="rahpardaznet-policy">بیمه نامه دریافت شده
                                                            است.</label>
                                                    ) : (
                                                        <label className="form-check-label text-danger"
                                                            htmlFor="rahpardaznet-policy">بیمه نامه دریافت نشده
                                                            است.</label>

                                                    )
                                                }
                                            </div>
                                            <div className="form-check rahpdrdaznet-border-bottom">
                                                <input tabIndex="20" className="form-check-input" type="checkbox" value=""
                                                    id="rahpardaznet-residence-verification"
                                                    onChange={(e) => setRk_residence_verification(e.target.checked)} />
                                                {
                                                    (rk_residence_verification == true) ? (
                                                        <label className="form-check-label text-success"
                                                            htmlFor="rahpardaznet-residence-verification">احراز سکونت
                                                            دریافت شده است.</label>
                                                    ) : (
                                                        <label className="form-check-label text-danger"
                                                            htmlFor="rahpardaznet-residence-verification">احراز سکونت
                                                            دریافت نشده است.</label>

                                                    )
                                                }
                                            </div>
                                            <div className="form-check rahpdrdaznet-border-bottom">
                                                <input tabIndex="21" className="form-check-input" type="checkbox" value=""
                                                    id="rahpardaznet-receipt"
                                                    onChange={(e) => setRk_receipt(e.target.checked)} />
                                                {
                                                    (rk_receipt == true) ? (
                                                        <label className="form-check-label text-success"
                                                            htmlFor="rahpardaznet-receipt">فیش قبض دریافت شده
                                                            است.</label>

                                                    ) : (
                                                        <label className="form-check-label text-danger"
                                                            htmlFor="rahpardaznet-receipt">فیش قبض دریافت نشده
                                                            است.</label>

                                                    )
                                                }
                                            </div>
                                        </div>

                                        {
                                            (rk_birth_certificate == true && rk_national_card == true && rk_policy == true && rk_residence_verification == true && rk_receipt == true) ? (
                                                <div className="col-12 pt-3">

                                                    <p className='alert alert-success'>تمامی مدارک دریافت شده اند.</p>
                                                </div>
                                            ) : ''}


                                    </div>
                                    {
                                        (documentItem.document_id > 0) ? (
                                            <div className='row rahpardaznet-cart rahpardaznet-file-note my-5  print-position'>
                                                <Header title={'یادداشت و فایل ها'} />
                                                <div className="row">
                                                    <div className="col-12 col-md-7 input-100">

                                                        <div>
                                                            <div className="form-group rahpardaznet-small-file">
                                                                <div className="file-loading">
                                                                    <input id="rahpardaznet-image-file"
                                                                        type="file" name="file"
                                                                        accept="image/*"
                                                                        data-min-file-count="1"
                                                                        multiple />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-5">
                                                        <div className="container">
                                                            <div className="rahpardaznet-list-message">

                                                                {
                                                                    (typeof RahpardaznetDetailsData == 'object' && RahpardaznetDetailsData.length > 0) ? (
                                                                        <>
                                                                            {
                                                                                RahpardaznetDetailsData.map((note, key) => (
                                                                                    <div className="message-candidate center-block">
                                                                                        <div className="row rahpardaznet-message-details">
                                                                                            <div className="col-xs-8 col-md-6 p-0">
                                                                                                <h6 className="message-name"> {note.user_id}</h6>
                                                                                            </div>
                                                                                            <div className="col-xs-4 col-md-6 p-0 text-left message-date">
                                                                                                {moment(note.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="row message-text">
                                                                                            {note.description} ({note.description.length} کاراکتر)
                                                                                        </div>
                                                                                    </div>
                                                                                ))
                                                                            }
                                                                        </>
                                                                    ) : (
                                                                        <div>یادداشتی جهت نمایش وجود ندارد.</div>
                                                                    )
                                                                }


                                                            </div>
                                                            <div className="messaging center-block">
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <form onSubmit={RahpardaznetSubmitMessage} className='rahpdrdaznet-border-bottom'>
                                                                            <div className="input-group">
                                                                                <input type="text" className="rahpardaznet-form-message"
                                                                                    value={RahpardaznetMessage}
                                                                                    onChange={(e) => setRahpardaznetMessage(e.target.value)}
                                                                                    placeholder="توضیحات را وارد نمایید." />

                                                                                <button className="rahpardaznet-button-send-message"
                                                                                    type="submit">ثبت
                                                                                </button>

                                                                            </div>
                                                                        </form>
                                                                    </div>
                                                                    <div className='col-md-12'>
                                                                        <div className='rahpardaznet-default-note-message'>
                                                                            <button type="button" onClick={(e) => RahpardaznetDefaultNote('یادداشت شماره ۱')}>یادداشت شماره ۱</button>
                                                                            <button type="button" onClick={(e) => RahpardaznetDefaultNote('یادداشت شماره ۲')}>یادداشت شماره ۲</button>
                                                                            <button type="button" onClick={(e) => RahpardaznetDefaultNote('یادداشت شماره ۳')}>یادداشت شماره ۳</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null
                                    }

                                    {/* <div className='row rahpardaznet-cart  my-5  print-position'>
                                        <Header title={'وضعیت سند'} />
                                        <div className="col-12  d-flex">
                                            {
                                                statuses.length > 0 ? (

                                                    statuses.map((row, key) => (
                                                        (rahkarpardaznet_document_status == row.id) ? (
                                                            <button
                                                                className='rahpardaznet-document-change-status active m-2'
                                                                key={key} id={row.id} disabled>
                                                                {row.name}
                                                            </button>
                                                        ) : (
                                                            <button className='rahpardaznet-document-change-status m-2'
                                                                key={key} id={row.id}
                                                                onClick={(e) => documentStatusUpdateHandler(row.id)}>
                                                                {row.name}
                                                            </button>
                                                        )

                                                    ))
                                                ) : null
                                            }
                                        </div>
                                    </div> */}

                                    {/* <div className='row rahpardaznet-cart my-5 print-position'>
    <Header title={'بایگانی سند'}/>
    <div className="col-6 ">
        <Select
                multiple={false}
                key='23'
                tab='23'
                col='col-12'
                name=''
                title='انتقال به انبار'
                value={transferToStore}
                onchange={(e) => transferStoreHandler(e.target.value)}
        status='1'
        data={archives}
        defaultValue={documentItem.store_id}

        />
        <Select
                multiple={false}
                key='24'
                tab='24'
                col='col-12'
                name=''
                title='طبقه بندی رده اول'
                value={partone}
                onchange={(e) => sectionOneSearchHandler(e.target.value)}
        status='1'
        target='1'
        data={sections}
        />
    </div>
    <div className="col-6 ">
        <Select
                multiple={false}
                key='25'
                tab='25'
                col='col-12'
                name=''
                title='طبقه بندی رده دوم'
                value={parttwo}
                onchange={(e) => sectionTwoSearchHandler(e.target.value)}
        status='1'
        target='1'
        data={partOne}
        />
        <Select
                multiple={false}
                key='26'
                tab='26'
                col='col-12'
                name=''
                title='طبقه بندی رده سوم'
                value={partthree}
                onchange={(e) => setPartthree(e.target.value)}
        status='1'
        data={partTwo}
        />
    </div>
</div> */}
                                </>
                            ) : null
                        ) : null
                    ) : null
                }

                <div className='row rahpardaznet-cart  my-5  print-position rahpardaznet-upload-file d-none'>
                    <Header title={'بارگذاری فایل ها'} />
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <div className="file-loading">
                                    <input id="image-file"
                                        type="file" name="file"
                                        accept="image/*"
                                        data-min-file-count="1"
                                        multiple />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    (documentItem && documentItem.length != 0 && response === true) ? (
                        <div className="row g-2 mb-5">
                            <div className="mx-1 col-6 col-md-12 d-flex justify-content-end me-auto p-0">
                                {
                                    (rk_document_transfer == true && rk_document_transfer != " " && rk_document_transfer != " " && OwnerBtnSubmit == '1') ? (
                                        <button
                                            tabIndex='27'
                                            onClick={documentUpdateTransferHandler}
                                            type="submit"
                                            className="print-no rahpardaznet-btn">
                                            {'ثبت انتقال سند'}

                                        </button>
                                    ) : null
                                }
                                {
                                    (rk_document_transfer != true && documentItem.saved == 'unsaved') ? (
                                        (!rk_buyer_mobile_validation || btnSubmit) ? (
                                            <button
                                                tabIndex='17'
                                                onClick={documentUpdateHandler}
                                                type="submit"
                                                className="print-no rahpardaznet-btn">
                                                {'ثبت مالک سند'}

                                            </button>
                                        ) : null

                                    ) : null
                                }
                                {
                                    (rk_document_transfer != true && documentItem && documentItem.length != 0 && response === true && documentItem.saved == 'saved' && documentItem.customer_data != null && documentItem.customer_data != []) ? (
                                        <>
                                            <button
                                                onClick={documentPrintHandlerone}
                                                type="submit"
                                                className="print-no rahpardaznet-btn"
                                            >
                                                {'  چاپ صفحه اول سند   '}
                                                <i className="fa-solid fa-print fa-fw fa-stack fa-lg"></i>
                                            </button>
                                            <button
                                                onClick={documentPrintHandlertwo}
                                                type="submit"
                                                className="print-no rahpardaznet-btn"
                                            >
                                                {'  چاپ صفحه دوم سند  '}
                                                <i className="fa-solid fa-print fa-fw fa-stack fa-lg"></i>
                                            </button>
                                        </>

                                    ) : null
                                }
                            </div>
                        </div>
                    ) : null
                    // <div className="row g-2 px-0 mb-5">
                    //     <div className="row mx-1 d-grid gap-2 col-6 col-md-3 me-auto">
                    //         <button
                    //             tabIndex='6'
                    //             onClick={documentSearchHandler}
                    //             type="submit"
                    //             className="print-no position-relative px-4 py-1 btn btn-dark ">
                    //             <span style={{paddingRight: '20px'}}>
                    //             {'  جستجوی انبار  '}
                    //             <i className="fa-solid fa-arrow-left fa-rotate-by fa-fw fa-stack fa-lg"></i>
                    //             </span>
                    //         </button>
                    //     </div>
                    // </div>
                    // )
                }

            </div>
        </>
        // ) : (
        //     <div className='row rahpardaznet-cart  my-5  text-center'>
        //         <h3 className='text-center' onClick={internetMessageHandler}>{internetMessage}</h3>
        //     </div>
        // )
    )
}

export default DocumentRequest;